// Root state constants
export const SET_LANGUAGE = 'SET_LANGUAGE'
export const SET_THEME = 'SET_THEME'
export const SET_TAGS_DISPLAY = 'SET_TAGS_DISPLAY'
export const SET_VALUATION_PRICES = 'SET_VALUATION_PRICES'
export const SET_QUERY = 'SET_QUERY'
export const SET_RESULT_INDEX = 'SET_RESULT_INDEX'
export const SET_RENAMING_ID = 'SET_RENAMING_ID'
export const SET_EDITING_ID = 'SET_EDITING_ID'
export const UPDATE_BUDGET_REQUEST = 'UPDATE_BUDGET_REQUEST'

// Auth module constants
export const SET_USER = 'SET_USER'

// Notes module constants
export const SET_NOTES = 'SET_NOTES'
export const SET_ACTIVE_CONTACT = 'SET_ACTIVE_CONTACT'
export const SET_ACTIVE_NOTE = 'SET_ACTIVE_NOTE'
export const SET_ACTIVE_KEY = 'SET_ACTIVE_KEY'
export const SET_APPRAISALFILES = 'SET_APPRAISALFILES'
export const SET_USER_ROLE = 'SET_USER_ROLE'
export const SET_BECPROPERTIES = 'SET_BECPROPERTIES'
export const CREATE_NOTE = 'CREATE_NOTE'
export const TOGGLE_IS_PUBLIC = 'TOGGLE_IS_PUBLIC'
export const SET_BDE_APPRAISAL_FILES = 'SET_BDE_APPRAISAL_FILES'
export const SET_BDE_REALESTATE_FILES = 'SET_BDE_REALESTATE_FILES'
export const SET_BDE_COMPARABLE_FILES = 'SET_BDE_COMPARABLE_FILES'
export const SET_BDE_RELATIONSHIPS_FILES = 'SET_BDE_RELATIONSHIPS_FILES'

// Stats
export const SET_STATS_CURRENT= 'SET_STATS_CURRENT'

// App
export const SET_APPRAISALS = 'SET_APPRAISALS'
export const SET_MARKETSTUDIES= 'SET_MARKETSTUDIES'
export const SET_AD_COMPARABLES = 'SET_AD_COMPARABLES'
export const SET_WARNINGS = 'SET_WARNINGS'
export const SET_CONSTRAINTS = 'SET_CONSTRAINTS'

// ad
export const CREATE_NEW_AD = 'CREATE_NEW_AD'
export const DELETE_AD = 'DELETE_AD'
export const RESET_AD = 'RESET_AD'
export const SET_AD = 'SET_AD'
export const SET_AD_CADASTRAL_REFERENCE = 'SET_AD_CADASTRAL_REFERENCE'
export const SET_AD_CENSUS_SECTION_CODE = 'SET_AD_CENSUS_SECTION_CODE'
export const SET_AD_COUNTRY = 'SET_AD_COUNTRY'
export const SET_AD_DATE_CREATED = 'SET_AD_DATE_CREATED'
export const SET_AD_DATE_MODIFIED = 'SET_AD_DATE_MODIFIED'
export const SET_AD_DESCRIPTION = 'SET_AD_DESCRIPTION'
export const SET_AD_DIRTYNESS = 'SET_AD_DIRTYNESS'
export const SET_AD_DOOR = 'SET_AD_DOOR'
export const SET_AD_EPSG25831_X = 'SET_AD_EPSG25831_X'
export const SET_AD_EPSG25831_Y = 'SET_AD_EPSG25831_Y'
export const SET_AD_FLOOR = 'SET_AD_FLOOR'
export const SET_AD_GEOHASH = 'SET_AD_GEOHASH'
export const SET_AD_GOOGLE_FORMATTED_ADDRESS = 'SET_AD_GOOGLE_FORMATTED_ADDRESS'
export const SET_AD_GOOGLE_VIEWPORT = 'SET_AD_GOOGLE_VIEWPORT'
export const SET_AD_ID = 'SET_AD_ID'
export const SET_AD_LAT = 'SET_AD_LAT'
export const SET_AD_LNG = 'SET_AD_LNG'
export const SET_AD_MUNICIPALITY = 'SET_AD_MUNICIPALITY'
export const SET_AD_PARENT_PATH = 'SET_AD_PARENT_PATH'
export const SET_AD_PATH = 'SET_AD_PATH'
export const SET_AD_POSTAL_CODE = 'SET_AD_POSTAL_CODE'
export const SET_AD_PROVINCE = 'SET_AD_PROVINCE'
export const SET_AD_STAIRCASE = 'SET_AD_STAIRCASE'
export const SET_AD_STREET_NAME = 'SET_AD_STREET_NAME'
export const SET_AD_STREET_NUMBER = 'SET_AD_STREET_NUMBER'
export const UPDATE_AD = 'UPDATE_AD'
export const SET_AD_CADASTRAL_AREA = 'SET_AD_CADASTRAL_AREA'
export const SET_AD_REGISTRY_IDUFIR = 'SET_AD_REGISTRY_IDUFIR'
export const SET_AD_AD_DATE = 'SET_AD_AD_DATE'
export const SET_AD_AD_TYPE = 'SET_AD_AD_TYPE'
export const SET_AD_AD_YEAR = 'SET_AD_AD_YEAR'
export const SET_AD_ADOPTED_AREA = 'SET_AD_ADOPTED_AREA'
export const SET_AD_ADOPTED_AGE = 'SET_AD_ADOPTED_AGE'
export const SET_AD_AIR_CONDITIONING = 'SET_AD_AIR_CONDITIONING'
export const SET_AD_BATHROOMS_NUMBER = 'SET_AD_BATHROOMS_NUMBER'
export const SET_AD_BEDROOMS_NUMBER = 'SET_AD_BEDROOMS_NUMBER'
export const SET_AD_COVERED_OUTDOOR_AREA = 'SET_AD_COVERED_OUTDOOR_AREA'
export const SET_AD_UNCOVERED_OUTDOOR_AREA = 'SET_AD_UNCOVERED_OUTDOOR_AREA'
export const SET_AD_CONSTRUCTION_YEAR = 'SET_AD_CONSTRUCTION_YEAR'
export const SET_AD_DWELLING_TYPE = 'SET_AD_DWELLING_TYPE'
export const SET_AD_ESTIMATED_SALE_PRICE = 'SET_AD_ESTIMATED_SALE_PRICE'
export const SET_AD_EXTERNAL_STORAGE_ROOM = 'SET_AD_EXTERNAL_STORAGE_ROOM'
export const SET_AD_FLOOR_NUMBER = 'SET_AD_FLOOR_NUMBER'
export const SET_AD_FLOOR_TYPE = 'SET_AD_FLOOR_TYPE'
export const SET_AD_GREEN_AREAS = 'SET_AD_GREEN_AREAS'
export const SET_AD_HEATING = 'SET_AD_HEATING'
export const SET_AD_LAST_RENOVATION_YEAR = 'SET_AD_LAST_RENOVATION_YEAR'
export const SET_AD_LIFT = 'SET_AD_LIFT'
export const SET_AD_OFFER_PRICE = 'SET_AD_OFFER_PRICE'
export const SET_AD_PARKING_LOTS_NUMBER = 'SET_AD_PARKING_LOTS_NUMBER'
export const SET_AD_QUALITY_OF_NEIGHBOURHOOD = 'SET_AD_QUALITY_OF_NEIGHBOURHOOD'
export const SET_AD_QUALITY_OF_SITUATION = 'SET_AD_QUALITY_OF_SITUATION'
export const SET_AD_QUALITY_OF_CONSTRUCTION = 'SET_AD_QUALITY_OF_CONSTRUCTION'
export const SET_AD_QUALITY_OF_REALESTATE = 'SET_AD_QUALITY_OF_REALESTATE'
export const SET_AD_SPORTS_FACILITIES = 'SET_AD_SPORTS_FACILITIES'
export const SET_AD_SWIMMING_POOL = 'SET_AD_SWIMMING_POOL'
export const SET_AD_AD_ADDRESS = 'SET_AD_AD_ADDRESS'
export const SET_AD_BUILT_AREA = 'SET_AD_BUILT_AREA'
export const SET_AD_CAPTURE_DATE = 'SET_AD_CAPTURE_DATE'
export const SET_AD_AD_DATA_TYPE = 'SET_AD_DATA_TYPE'
export const SET_AD_AD_CODE = 'SET_AD_AD_CODE'
export const SET_AD_INTERIOR_VISIT_CHECK = 'SET_AD_INTERIOR_VISIT_CHECK'
export const SET_AD_LAND_AREA = 'SET_AD_LAND_AREA'
export const SET_AD_NET_AREA = 'SET_AD_NET_AREA'
export const SET_AD_CADASTRAL_DATA_CHECK = 'SET_AD_CADASTRAL_DATA_CHECK'
export const SET_AD_CONTACT_TELEPHONE = 'SET_AD_CONTACT_TELEPHONE'
export const SET_AD_NOTES_1 = 'SET_AD_NOTES_1'
export const SET_AD_NOTES_2 = 'SET_AD_NOTES_2'
export const SET_AD_ORIENTATION = 'SET_AD_ORIENTATION'
export const SET_AD_PROPERTY_TYPE = 'SET_AD_PROPERTY_TYPE'
export const SET_AD_SOURCE = 'SET_AD_SOURCE'
export const SET_AD_URL = 'SET_AD_URL'
export const SET_AD_BLOCK = 'SET_AD_BLOCK'
export const SET_AD_CONTACT_NAME = 'SET_AD_CONTACT_NAME'
export const SET_AD_OFFER_UNIT_PRICE = 'SET_AD_OFFER_UNIT_PRICE'
export const SET_AD_CONSERVATION_STATUS = 'SET_AD_CONSERVATION_STATUS'
export const SET_AD_OFFER_PRICE_REDUCTION_PCT = 'SET_AD_OFFER_PRICE_REDUCTION_PCT'
export const SET_AD_ESTIMATED_UNIT_SALE_PRICE = 'SET_AD_ESTIMATED_UNIT_SALE_PRICE'

// ad_comparable
export const CREATE_NEW_AD_COMPARABLE = 'CREATE_NEW_AD_COMPARABLE'
export const DELETE_AD_COMPARABLE = 'DELETE_AD_COMPARABLE'
export const RESET_AD_COMPARABLE = 'RESET_AD_COMPARABLE'
export const SET_AD_COMPARABLE = 'SET_AD_COMPARABLE'
export const SET_AD_COMPARABLE_DATE_CREATED = 'SET_AD_COMPARABLE_DATE_CREATED'
export const SET_AD_COMPARABLE_DATE_MODIFIED = 'SET_AD_COMPARABLE_DATE_MODIFIED'
export const SET_AD_COMPARABLE_DIRTYNESS = 'SET_AD_COMPARABLE_DIRTYNESS'
export const SET_AD_COMPARABLE_ID = 'SET_AD_COMPARABLE_ID'
export const SET_AD_COMPARABLE_PARENT_PATH = 'SET_AD_COMPARABLE_PARENT_PATH'
export const SET_AD_COMPARABLE_PATH = 'SET_AD_COMPARABLE_PATH'
export const UPDATE_AD_COMPARABLE = 'UPDATE_AD_COMPARABLE'
export const SET_AD_COMPARABLE_DESCRIPTION = 'SET_AD_COMPARABLE_DESCRIPTION'

// ad_municipalities
export const SET_AD_MUNICIPALITIES = 'SET_AD_MUNICIPALITIES'

// realestate
export const CREATE_NEW_REALESTATE = 'CREATE_NEW_REALESTATE'
export const DELETE_REALESTATE = 'DELETE_REALESTATE'
export const RESET_REALESTATE = 'RESET_REALESTATE'
export const SET_REALESTATE = 'SET_REALESTATE'
export const SET_REALESTATE_CADASTRAL_REFERENCE = 'SET_REALESTATE_CADASTRAL_REFERENCE'
export const SET_REALESTATE_CENSUS_SECTION_CODE = 'SET_REALESTATE_CENSUS_SECTION_CODE'
export const SET_REALESTATE_COUNTRY = 'SET_REALESTATE_COUNTRY'
export const SET_REALESTATE_DATE_CREATED = 'SET_REALESTATE_DATE_CREATED'
export const SET_REALESTATE_DATE_MODIFIED = 'SET_REALESTATE_DATE_MODIFIED'
export const SET_REALESTATE_DESCRIPTION = 'SET_REALESTATE_DESCRIPTION'
export const SET_REALESTATE_DIRTYNESS = 'SET_REALESTATE_DIRTYNESS'
export const SET_REALESTATE_DOOR = 'SET_REALESTATE_DOOR'
export const SET_REALESTATE_EPSG25831_X = 'SET_REALESTATE_EPSG25831_X'
export const SET_REALESTATE_EPSG25831_Y = 'SET_REALESTATE_EPSG25831_Y'
export const SET_REALESTATE_FLOOR = 'SET_REALESTATE_FLOOR'
export const SET_REALESTATE_FLOOR_NUMBER = 'SET_REALESTATE_FLOOR_NUMBER'
export const SET_REALESTATE_GEOHASH = 'SET_REALESTATE_GEOHASH'
export const SET_REALESTATE_GOOGLE_FORMATTED_ADDRESS = 'SET_REALESTATE_GOOGLE_FORMATTED_ADDRESS'
export const SET_REALESTATE_GOOGLE_VIEWPORT = 'SET_REALESTATE_GOOGLE_VIEWPORT'
export const SET_REALESTATE_ID = 'SET_REALESTATE_ID'
export const SET_REALESTATE_LAT = 'SET_REALESTATE_LAT'
export const SET_REALESTATE_LNG = 'SET_REALESTATE_LNG'
export const SET_REALESTATE_MUNICIPALITY = 'SET_REALESTATE_MUNICIPALITY'
export const SET_REALESTATE_PARENT_PATH = 'SET_REALESTATE_PARENT_PATH'
export const SET_REALESTATE_PATH = 'SET_REALESTATE_PATH'
export const SET_REALESTATE_POSTAL_CODE = 'SET_REALESTATE_POSTAL_CODE'
export const SET_REALESTATE_PROPERTY_TYPE = 'SET_REALESTATE_PROPERTY_TYPE'
export const SET_REALESTATE_PROVINCE = 'SET_REALESTATE_PROVINCE'
export const SET_REALESTATE_REGISTRY_NAME = 'SET_REALESTATE_REGISTRY_NAME'
export const SET_REALESTATE_STAIRCASE = 'SET_REALESTATE_STAIRCASE'
export const SET_REALESTATE_STREET_NAME = 'SET_REALESTATE_STREET_NAME'
export const SET_REALESTATE_STREET_NUMBER = 'SET_REALESTATE_STREET_NUMBER'
export const SET_REALESTATE_MAP_GOOGLE_01_URL = 'SET_REALESTATE_MAP_GOOGLE_01_URL'
export const SET_REALESTATE_MAP_GOOGLE_01_LAT = 'SET_REALESTATE_MAP_GOOGLE_01_LAT'
export const SET_REALESTATE_MAP_GOOGLE_01_LNG = 'SET_REALESTATE_MAP_GOOGLE_01_LNG'
export const SET_REALESTATE_MAP_GOOGLE_01_ZOOM = 'SET_REALESTATE_MAP_GOOGLE_01_ZOOM'
export const SET_REALESTATE_MAP_GOOGLE_02_URL = 'SET_REALESTATE_MAP_GOOGLE_02_URL'
export const SET_REALESTATE_MAP_GOOGLE_02_LAT = 'SET_REALESTATE_MAP_GOOGLE_02_LAT'
export const SET_REALESTATE_MAP_GOOGLE_02_LNG = 'SET_REALESTATE_MAP_GOOGLE_02_LNG'
export const SET_REALESTATE_MAP_GOOGLE_02_ZOOM = 'SET_REALESTATE_MAP_GOOGLE_02_ZOOM'
export const SET_REALESTATE_MAP_GOOGLE_03_URL = 'SET_REALESTATE_MAP_GOOGLE_03_URL'
export const SET_REALESTATE_MAP_GOOGLE_03_LAT = 'SET_REALESTATE_MAP_GOOGLE_03_LAT'
export const SET_REALESTATE_MAP_GOOGLE_03_LNG = 'SET_REALESTATE_MAP_GOOGLE_03_LNG'
export const SET_REALESTATE_MAP_GOOGLE_03_ZOOM = 'SET_REALESTATE_MAP_GOOGLE_03_ZOOM'
export const SET_REALESTATE_FULL_ADDRESS = 'SET_REALESTATE_FULL_ADDRESS'
export const SET_REALESTATE_SHORT_ADDRESS = 'SET_REALESTATE_SHORT_ADDRESS'
export const SET_REALESTATE_BLOCK = 'SET_REALESTATE_BLOCK'
export const SET_REALESTATES = 'SET_REALESTATES'
export const SET_REALESTATE_AREA_ADS_MARKERS = 'SET_REALESTATE_AREA_ADS_MARKERS'
export const SET_REALESTATE_AREA_AVERAGE_PRICE = 'SET_REALESTATE_AREA_AVERAGE_PRICE'
export const SET_REALESTATE_AREA_AVERAGE_PRICE_COEF = 'SET_REALESTATE_AREA_AVERAGE_PRICE_COEF'
export const SET_REALESTATE_ADOPTED_AREA_AVERAGE_PRICE = 'SET_REALESTATE_ADOPTED_AREA_AVERAGE_PRICE'
export const SET_REALESTATE_ESTIMATED_BUILT_AREA = 'SET_REALESTATE_ESTIMATED_BUILT_AREA'
export const SET_REALESTATE_PRE_APPRAISAL_VALUE = 'SET_REALESTATE_PRE_APPRAISAL_VALUE'
export const SET_REALESTATE_TRAVEL_ONE_WAY_HOURS = 'SET_REALESTATE_TRAVEL_ONE_WAY_HOURS'
export const SET_REALESTATE_TRAVEL_BOTH_WAYS_HOURS = 'SET_REALESTATE_TRAVEL_BOTH_WAYS_HOURS'
export const SET_REALESTATE_TRAVEL_FEES_PER_HOUR = 'SET_REALESTATE_TRAVEL_FEES_PER_HOUR'
export const SET_REALESTATE_CAR_FUEL_EXPENSES_ONE_WAY = 'SET_REALESTATE_CAR_FUEL_EXPENSES_ONE_WAY'
export const SET_REALESTATE_CAR_FUEL_EXPENSES_BOTH_WAYS = 'SET_REALESTATE_CAR_FUEL_EXPENSES_BOTH_WAYS'
export const SET_REALESTATE_CAR_TOLL_EXPENSES_ONE_WAY = 'SET_REALESTATE_CAR_TOLL_EXPENSES_ONE_WAY'
export const SET_REALESTATE_CAR_TOLL_EXPENSES_BOTH_WAYS = 'SET_REALESTATE_CAR_TOLL_EXPENSES_BOTH_WAYS'
export const SET_REALESTATE_CAR_EXPENSES_ONE_WAY = 'SET_REALESTATE_CAR_EXPENSES_ONE_WAY'
export const SET_REALESTATE_CAR_EXPENSES_BOTH_WAYS = 'SET_REALESTATE_CAR_EXPENSES_BOTH_WAYS'
export const SET_REALESTATE_TOTAL_TRAVEL_FEES = 'SET_REALESTATE_TOTAL_TRAVEL_FEES'
export const SET_REALESTATE_QUOTE_BASE_FEES = 'SET_REALESTATE_QUOTE_BASE_FEES'
export const SET_REALESTATE_QUOTE_EXCESS_PCT = 'SET_REALESTATE_QUOTE_EXCESS_PCT'
export const SET_REALESTATE_QUOTE_BASE_PRICE = 'SET_REALESTATE_QUOTE_BASE_PRICE'
export const SET_REALESTATE_QUOTE_BASE_PRICE_COEF = 'SET_REALESTATE_QUOTE_BASE_PRICE_COEF'
export const SET_REALESTATE_QUOTE_APPRAISAL_TYPE_IS_ECO = 'SET_REALESTATE_QUOTE_APPRAISAL_TYPE_IS_ECO'
export const SET_REALESTATE_QUOTE_PRICE_INCL_TRAVEL_EXPENSES = 'SET_REALESTATE_QUOTE_PRICE_INCL_TRAVEL_EXPENSES'
export const SET_REALESTATE_AREA_ADS_QUERY_STARTDATE = 'SET_REALESTATE_AREA_ADS_QUERY_STARTDATE'
export const SET_REALESTATE_AREA_ADS_QUERY_LIMITDATE = 'SET_REALESTATE_AREA_ADS_QUERY_LIMITDATE'
export const SET_REALESTATE_AREA_ADS_QUERY_DISTANCE = 'SET_REALESTATE_AREA_ADS_QUERY_DISTANCE'
export const SET_REALESTATE_INVOICE_BASE_FEES = 'SET_REALESTATE_INVOICE_BASE_FEES'
export const SET_REALESTATE_INVOICE_EXCESS_PCT = 'SET_REALESTATE_INVOICE_EXCESS_PCT'
export const SET_REALESTATE_INVOICE_BASE_PRICE = 'SET_REALESTATE_INVOICE_BASE_PRICE'
export const SET_REALESTATE_INVOICE_BASE_PRICE_COEF = 'SET_REALESTATE_INVOICE_BASE_PRICE_COEF'
export const SET_REALESTATE_INVOICE_APPRAISAL_TYPE_IS_ECO = 'SET_REALESTATE_INVOICE_APPRAISAL_TYPE_IS_ECO'
export const SET_REALESTATE_QUOTE_EXCESS = 'SET_REALESTATE_QUOTE_EXCESS'
export const SET_REALESTATE_ASSET_TYPE = 'SET_REALESTATE_ASSET_TYPE'
export const SET_REALESTATE_DWELLING_TYPE = 'SET_REALESTATE_DWELLING_TYPE'
export const SET_REALESTATE_FLOOR_TYPE = 'SET_REALESTATE_FLOOR_TYPE'
export const UPDATE_REALESTATE = 'UPDATE_REALESTATE'

// realestate_appraisals
export const SET_ALL_REALESTATE_APPRAISALS = 'SET_ALL_REALESTATE_APPRAISALS'
export const SET_REALESTATE_APPRAISALS = 'SET_REALESTATE_APPRAISALS'

// realestate_marketstudies
export const SET_REALESTATE_MARKETSTUDIES = 'SET_REALESTATE_MARKETSTUDIES'
export const SET_TEMP_REALESTATE_MARKETSTUDIES = 'SET_TEMP_REALESTATE_MARKETSTUDIES'

// realestate_projects
export const SET_ALL_REALESTATE_PROJECTS = 'SET_ALL_REALESTATE_PROJECTS'
export const SET_REALESTATE_PROJECTS = 'SET_REALESTATE_PROJECTS'

// realestate_municipalities
export const SET_REALESTATE_MUNICIPALITIES = 'SET_REALESTATE_MUNICIPALITIES'

// appraisal
export const CREATE_NEW_APPRAISAL = 'CREATE_NEW_APPRAISAL'
export const DELETE_APPRAISAL = 'DELETE_APPRAISAL'
export const RESET_APPRAISAL = 'RESET_APPRAISAL'
export const SET_APPRAISAL = 'SET_APPRAISAL'
export const SET_APPRAISAL_DATE_CREATED = 'SET_APPRAISAL_DATE_CREATED'
export const SET_APPRAISAL_DATE_MODIFIED = 'SET_APPRAISAL_DATE_MODIFIED'
export const SET_APPRAISAL_DIRTYNESS = 'SET_APPRAISAL_DIRTYNESS'
export const SET_APPRAISAL_ID = 'SET_APPRAISAL_ID'
export const SET_APPRAISAL_PARENT_PATH = 'SET_APPRAISAL_PARENT_PATH'
export const SET_APPRAISAL_PATH = 'SET_APPRAISAL_PATH'
export const SET_APPRAISAL_PURPOSE = 'SET_APPRAISAL_PURPOSE'
export const SET_APPRAISAL_PURPOSE_NOTES = 'SET_APPRAISAL_PURPOSE_NOTES'
export const SET_APPRAISAL_TYPE = 'SET_APPRAISAL_TYPE'
export const UPDATE_APPRAISAL = 'UPDATE_APPRAISAL'
export const SET_APPRAISAL_APPRAISALDATE = 'SET_APPRAISAL_APPRAISALDATE'
export const SET_APPRAISAL_VISITDATE = 'SET_APPRAISAL_VISITDATE'
export const SET_APPRAISAL_TECHNICIAN_VISITING = 'SET_APPRAISAL_TECHNICIAN_VISITING'
export const SET_APPRAISAL_DESCRIPTION = 'SET_APPRAISAL_DESCRIPTION'
export const SET_APPRAISAL_CHECKS_CADASTRAL_DATA = 'SET_APPRAISAL_CHECKS_CADASTRAL_DATA'
export const SET_APPRAISAL_CHECKS_CONSERVATION_STATUS = 'SET_APPRAISAL_CHECKS_CONSERVATION_STATUS'
export const SET_APPRAISAL_CHECKS_EXPROPRIATION_PROCEDURE = 'SET_APPRAISAL_CHECKS_EXPROPRIATION_PROCEDURE'
export const SET_APPRAISAL_CHECKS_EXPROPRIATION_PLAN = 'SET_APPRAISAL_CHECKS_EXPROPRIATION_PLAN'
export const SET_APPRAISAL_CHECKS_EXPROPRIATION_ADMIN_RULING = 'SET_APPRAISAL_CHECKS_EXPROPRIATION_ADMIN_RULING'
export const SET_APPRAISAL_CHECKS_EXPROPRIATION_FILE = 'SET_APPRAISAL_CHECKS_EXPROPRIATION_FILE'
export const SET_APPRAISAL_CHECKS_INTERIOR_VISIT = 'SET_APPRAISAL_CHECKS_INTERIOR_VISIT'
export const SET_APPRAISAL_CHECKS_OCCUPANCY = 'SET_APPRAISAL_CHECKS_OCCUPANCY'
export const SET_APPRAISAL_CHECKS_OTHER = 'SET_APPRAISAL_CHECKS_OTHER'
export const SET_APPRAISAL_CHECKS_REGISTRY_DATA = 'SET_APPRAISAL_CHECKS_REGISTRY_DATA'
export const SET_APPRAISAL_CHECKS_SERVITUDES = 'SET_APPRAISAL_CHECKS_SERVITUDES'
export const SET_APPRAISAL_CHECKS_SUBSIDY_STATUS = 'SET_APPRAISAL_CHECKS_SUBSIDY_STATUS'
export const SET_APPRAISAL_CHECKS_URBAN_PLANNING = 'SET_APPRAISAL_CHECKS_URBAN_PLANNING'
export const SET_APPRAISAL_DOCS_APPROVED_PROJECT = 'SET_APPRAISAL_DOCS_APPROVED_PROJECT'
export const SET_APPRAISAL_DOCS_CADASTRAL_DATA = 'SET_APPRAISAL_DOCS_CADASTRAL_DATA'
export const SET_APPRAISAL_DOCS_CONSTRUCTION_LICENSE = 'SET_APPRAISAL_DOCS_CONSTRUCTION_LICENSE'
export const SET_APPRAISAL_DOCS_CONSTRUCTION_LAST_CERTIFICATE = 'SET_APPRAISAL_CONSTRUCTION_LAST_CERTIFICATE'
export const SET_APPRAISAL_DOCS_CONSTRUCTION_CONTRACT = 'SET_APPRAISAL_DOCS_CONSTRUCTION_CONTRACT'
export const SET_APPRAISAL_DOCS_OCCUPANCY_STATUS = 'SET_APPRAISAL_DOCS_OCCUPANCY_STATUS'
export const SET_APPRAISAL_DOCS_OTHER = 'SET_APPRAISAL_DOCS_OTHER'
export const SET_APPRAISAL_DOCS_PHOTOGRAPHIC_REPORT = 'SET_APPRAISAL_DOCS_PHOTOGRAPHIC_REPORT'
export const SET_APPRAISAL_DOCS_PROPERTY_SKETCH = 'SET_APPRAISAL_DOCS_PROPERTY_SKETCH'
export const SET_APPRAISAL_DOCS_PROPERTY_TITLES = 'SET_APPRAISAL_DOCS_PROPERTY_TITLES'
export const SET_APPRAISAL_DOCS_SITUATION_PLAN = 'SET_APPRAISAL_DOCS_SITUATION_PLAN'
export const SET_APPRAISAL_DOCS_SUBSIDY_STATUS = 'SET_APPRAISAL_DOCS_SUBSIDY_STATUS'
export const SET_APPRAISAL_DOCS_TENYEAR_INSURANCE = 'SET_APPRAISAL_DOCS_TENYEAR_INSURANCE'
export const SET_APPRAISAL_DOCS_URBAN_PLAN = 'SET_APPRAISAL_DOCS_URBAN_PLAN'
export const SET_APPRAISAL_ADOPTED_AREA = 'SET_APPRAISAL_ADOPTED_AREA'
export const SET_APPRAISAL_LIFT = 'SET_APPRAISAL_LIFT'
export const SET_APPRAISAL_ADOPTED_AGE = 'SET_APPRAISAL_ADOPTED_AGE'
export const SET_APPRAISAL_PROPERTY_TYPE = 'SET_APPRAISAL_PROPERTY_TYPE'
export const SET_APPRAISAL_QUALITY_OF_NEIGHBOURHOOD = 'SET_APPRAISAL_QUALITY_OF_NEIGHBOURHOOD'
export const SET_APPRAISAL_QUALITY_OF_SITUATION = 'SET_APPRAISAL_QUALITY_OF_SITUATION'
export const SET_APPRAISAL_QUALITY_OF_CONSTRUCTION = 'SET_APPRAISAL_QUALITY_OF_CONSTRUCTION'
export const SET_APPRAISAL_QUALITY_OF_REALESTATE = 'SET_APPRAISAL_QUALITY_OF_REALESTATE'
export const SET_APPRAISAL_CONSERVATION_STATUS = 'SET_APPRAISAL_CONSERVATION_STATUS'
export const SET_APPRAISAL_FLOOR_NUMBER = 'SET_APPRAISAL_FLOOR_NUMBER'
export const SET_APPRAISAL_MARKET_VALUE = 'SET_APPRAISAL_MARKET_VALUE'
export const SET_APPRAISAL_MARKET_UNIT_VALUE = 'SET_APPRAISAL_MARKET_UNIT_VALUE'
export const SET_MARKET_VALUE_APPRAISER_ADJUSTMENT_PCT = 'SET_MARKET_VALUE_APPRAISER_ADJUSTMENT_PCT'
export const SET_APPRAISAL_ADOPTED_MARKET_VALUE = 'SET_APPRAISAL_MARKET_VALUE'
export const SET_APPRAISAL_ADOPTED_MARKET_UNIT_VALUE = 'SET_APPRAISAL_MARKET_UNIT_VALUE'
export const SET_APPRAISAL_BEC_PRICE = 'SET_APPRAISAL_BEC_PRICE'
export const SET_APPRAISAL_ADJUSTED_BEC_PRICE = 'SET_APPRAISAL_ADJUSTED_BEC_PRICE'
export const SET_APPRAISAL_BC = 'SET_APPRAISAL_BC'
export const SET_APPRAISAL_BC_PCT = 'SET_APPRAISAL_BC_PCT'
export const SET_APPRAISAL_GC = 'SET_APPRAISAL_GC'
export const SET_APPRAISAL_GC_PCT = 'SET_APPRAISAL_GC_PCT'
export const SET_APPRAISAL_BC_AND_GC_PCT = 'SET_APPRAISAL_BC_AND_GC_PCT'
export const SET_APPRAISAL_BC_AND_GC = 'SET_APPRAISAL_BC_AND_GC'
export const SET_APPRAISAL_CC = 'SET_APPRAISAL_CC'
export const SET_APPRAISAL_CC_PCT = 'SET_APPRAISAL_CC_PCT'
export const SET_APPRAISAL_HTL = 'SET_APPRAISAL_HTL'
export const SET_APPRAISAL_HTL_PCT = 'SET_APPRAISAL_HTL_PCT'
export const SET_APPRAISAL_INR = 'SET_APPRAISAL_INR'
export const SET_APPRAISAL_INR_PCT = 'SET_APPRAISAL_INR_PCT'
export const SET_APPRAISAL_GA = 'SET_APPRAISAL_GA'
export const SET_APPRAISAL_GA_PCT = 'SET_APPRAISAL_GA_PCT'
export const SET_APPRAISAL_GPD = 'SET_APPRAISAL_GPD'
export const SET_APPRAISAL_GPD_PCT = 'SET_APPRAISAL_GPD_PCT'
export const SET_APPRAISAL_OCT = 'SET_APPRAISAL_OCT'
export const SET_APPRAISAL_OCT_PCT = 'SET_APPRAISAL_OCT_PCT'
export const SET_APPRAISAL_GP = 'SET_APPRAISAL_GP'
export const SET_APPRAISAL_GP_PCT = 'SET_APPRAISAL_GP_PCT'
export const SET_APPRAISAL_CC_AND_GP = 'SET_APPRAISAL_CC_AND_GP'
export const SET_APPRAISAL_F = 'SET_APPRAISAL_F'
export const SET_APPRAISAL_CRB = 'SET_APPRAISAL_CRB'
export const SET_APPRAISAL_CCD = 'SET_APPRAISAL_CCD'
export const SET_APPRAISAL_TLR_PCT = 'SET_APPRAISAL_TLR_PCT'
export const SET_APPRAISAL_PR_PCT = 'SET_APPRAISAL_PR_PCT'
export const SET_APPRAISAL_AM_COEF = 'SET_APPRAISAL_AM_COEF'
export const SET_APPRAISAL_B1_PCT = 'SET_APPRAISAL_B1_PCT'
export const SET_APPRAISAL_B2_PCT = 'SET_APPRAISAL_B2_PCT'
export const SET_APPRAISAL_B_PCT = 'SET_APPRAISAL_B_PCT'
export const SET_APPRAISAL_B_REMAINING_PCT = 'SET_APPRAISAL_B_REMAINING_PCT'
export const SET_APPRAISAL_I_PCT = 'SET_APPRAISAL_I_PCT'
export const SET_APPRAISAL_TENANT_AGE_YEARS = 'SET_APPRAISAL_TENANT_AGE_YEARS'
export const SET_APPRAISAL_TENANT_LIFE_EXPECTANCY_YEARS = 'SET_APPRAISAL_TENANT_LIFE_EXPECTANCY_YEARS'
export const SET_APPRAISAL_TENANT_REMAINING_LIFE_EXPECTANCY_YEARS = 'SET_APPRAISAL_TENANT_REMAINING_LIFE_EXPECTANCY_YEARS'
export const SET_APPRAISAL_CESSION_BOOLEAN = 'SET_APPRAISAL_CESSION_BOOLEAN'
export const SET_APPRAISAL_CESSION_GROSS_MONTHLY_INCOME = 'SET_APPRAISAL_CESSION_GROSS_MONTHLY_INCOME'
export const SET_APPRAISAL_CESSION_GROSS_YEARLY_INCOME = 'SET_APPRAISAL_CESSION_GROSS_YEARLY_INCOME'
export const SET_APPRAISAL_CESSION_NET_YEARLY_INCOME = 'SET_APPRAISAL_CESSION_NET_YEARLY_INCOME'
export const SET_APPRAISAL_CESSION_CONTRACT_PERIOD_YEARS = 'SET_APPRAISAL_CESSION_CONTRACT_PERIOD_YEARS'
export const SET_APPRAISAL_CESSION_CONTRACT_REMAINING_YEARS = 'SET_APPRAISAL_CESSION_CONTRACT_REMAINING_YEARS'
export const SET_APPRAISAL_CESSION_CONTRACT_START_DATE = 'SET_APPRAISAL_CESSION_CONTRACT_START_DATE'
export const SET_APPRAISAL_LANDLORD_EXPENSES_PCT = 'SET_APPRAISAL_LANDLORD_EXPENSES_PCT'
export const SET_APPRAISAL_REDUCTION_PCT = 'SET_APPRAISAL_REDUCTION_PCT'
export const SET_APPRAISAL_ADJUSTMENT_COEF = 'SET_APPRAISAL_ADJUSTMENT_COEF'
export const SET_APPRAISAL_USUFRUCTUARY_AGE_YEARS = 'SET_APPRAISAL_USUFRUCTUARY_AGE_YEARS'
export const SET_APPRAISAL_USEFUL_LIFE_YEARS = 'SET_APPRAISAL_USEFUL_LIFE_YEARS'
export const SET_APPRAISAL_REMAINING_USEFUL_LIFE_YEARS = 'SET_APPRAISAL_REMAINING_USEFUL_LIFE_YEARS'
export const SET_APPRAISAL_MAX_LEGAL_PRICE = 'SET_APPRAISAL_MAX_LEGAL_PRICE'
export const SET_APPRAISAL_MAX_LEGAL_AREA = 'SET_APPRAISAL_MAX_LEGAL_AREA'
export const SET_APPRAISAL_MATERIAL_EXECUTION_COST = 'SET_APPRAISAL_MATERIAL_EXECUTION_COST'
export const SET_APPRAISAL_DEPRECATED_MATERIAL_EXECUTION_COST = 'SET_APPRAISAL_DEPRECATED_MATERIAL_EXECUTION_COST'
export const SET_APPRAISAL_MEC_ADJUSTMENT_COEF = 'SET_APPRAISAL_MEC_ADJUSTMENT_COEF'
export const SET_APPRAISAL_ADOPTED_MATERIAL_EXECUTION_COST = 'SET_APPRAISAL_ADOPTED_MATERIAL_EXECUTION_COST'
export const SET_APPRAISAL_PHYSICAL_DEPRECIATION_PCT = 'SET_APPRAISAL_PHYSICAL_DEPRECIATION_PCT'
export const SET_APPRAISAL_FUNCTIONAL_DEPRECIATION_PCT = 'SET_APPRAISAL_FUNCTIONAL_DEPRECIATION_PCT'
export const SET_APPRAISAL_TOTAL_DEPRECIATION_PCT = 'SET_APPRAISAL_TOTAL_DEPRECIATION_PCT'
export const SET_APPRAISAL_TOTAL_CONSTRUCTION_PROGRESS_PCT = 'SET_APPRAISAL_TOTAL_CONSTRUCTION_PROGRESS_PCT'
export const SET_APPRAISAL_MARKET_VALUE_APPRAISER_ADJUSTMENT_PCT = 'SET_APPRAISAL_MARKET_VALUE_APPRAISER_ADJUSTMENT_PCT'
export const SET_APPRAISAL_DEPRECATED_LAND_AND_CC = 'SET_APPRAISAL_DEPRECATED_LAND_AND_CC'
export const SET_APPRAISAL_FINISHED_REALESTATE_CRN = 'SET_APPRAISAL_FINISHED_REALESTATE_CRN'
export const SET_APPRAISAL_CCR = 'SET_APPRAISAL_CCR'
export const SET_APPRAISAL_EXECUTED_CONSTRUCTION_COST = 'SET_APPRAISAL_EXECUTED_CONSTRUCTION_COST'
export const SET_APPRAISAL_UNDER_CONSTRUCTION_REALESTATE_CRN = 'SET_APPRAISAL_UNDER_CONSTRUCTION_REALESTATE_CRN'
export const SET_APPRAISAL_K = 'SET_APPRAISAL_K'
export const SET_APPRAISAL_REPERCUSSION_METHOD_LAND_VALUE = 'SET_APPRAISAL_REPERCUSSION_METHOD_LAND_VALUE'
export const SET_APPRAISAL_COST_METHOD_CONSTRUCTION_CRB_VALUE = 'SET_APPRAISAL_COST_METHOD_CONSTRUCTION_CRB_VALUE'
export const SET_APPRAISAL_COST_METHOD_CONSTRUCTION_CRN_VALUE = 'SET_APPRAISAL_COST_METHOD_CONSTRUCTION_CRN_VALUE'
export const SET_APPRAISAL_COST_METHOD_REALESTATE_CRB_VALUE = 'SET_APPRAISAL_COST_METHOD_REALESTATE_CRB_VALUE'
export const SET_APPRAISAL_COST_METHOD_REALESTATE_CRN_VALUE = 'SET_APPRAISAL_COST_METHOD_REALESTATE_CRN_VALUE'
export const SET_APPRAISAL_COMPARISON_METHOD = 'SET_APPRAISAL_COMPARISON_METHOD'
export const SET_APPRAISAL_ADJUSTED_MARKET_VALUE = 'SET_APPRAISAL_ADJUSTED_MARKET_VALUE'
export const SET_APPRAISAL_MAX_LEGAL_METHOD = 'SET_APPRAISAL_MAX_LEGAL_METHOD'
export const SET_APPRAISAL_VC = 'SET_APPRAISAL_VC'
export const SET_APPRAISAL_INCOME_PERPETUITY_UPDATE_METHOD = 'SET_APPRAISAL_INCOME_PERPETUITY_UPDATE_METHOD'
export const SET_APPRAISAL_U = 'SET_APPRAISAL_U'
export const SET_APPRAISAL_RESIDUAL_DEPRECIATION_PCT = 'SET_APPRAISAL_RESIDUAL_DEPRECIATION_PCT'
export const SET_APPRAISAL_RESIDUAL_DEPRECIATION = 'SET_APPRAISAL_RESIDUAL_DEPRECIATION'
export const SET_APPRAISAL_REALESTATE_RESIDUAL_VALUE = 'SET_APPRAISAL_REALESTATE_RESIDUAL_VALUE'
export const SET_APPRAISAL_I = 'SET_APPRAISAL_I'
export const SET_APPRAISAL_NP = 'SET_APPRAISAL_NP'
export const SET_APPRAISAL_COEF_1 = 'SET_APPRAISAL_COEF_1'
export const SET_APPRAISAL_CURRENT_FUTURE_INCOME_VALUE = 'SET_APPRAISAL_CURRENT_FUTURE_INCOME_VALUE'
export const SET_APPRAISAL_COEF_2 = 'SET_APPRAISAL_COEF_2'
export const SET_APPRAISAL_UPDATED_REVERSION_VALUE = 'SET_APPRAISAL_UPDATED_REVERSION_VALUE'
export const SET_APPRAISAL_UPDATE_VALUE = 'SET_APPRAISAL_UPDATE_VALUE'
export const SET_APPRAISAL_INSURANCE_VALUE = 'SET_APPRAISAL_INSURANCE_VALUE'
export const SET_APPRAISAL_VU_COEF = 'SET_APPRAISAL_VU_COEF'
export const SET_APPRAISAL_USUFRUCT_VALUE = 'SET_APPRAISAL_USUFRUCT_VALUE'
export const SET_APPRAISAL_BARE_OWNERSHIP_VALUE = 'SET_APPRAISAL_BARE_OWNERSHIP_VALUE'
export const SET_APPRAISAL_REALESTATE_TOTAL_ADOPTED_VALUE = 'SET_APPRAISAL_REALESTATE_TOTAL_ADOPTED_VALUE'
export const SET_APPRAISAL_REALESTATE_ADOPTED_APPRAISAL_METHOD = 'SET_APPRAISAL_REALESTATE_ADOPTED_APPRAISAL_METHOD'
export const SET_APPRAISAL_REALESTATE_ID = 'SET_APPRAISAL_REALESTATE_ID'
export const SET_APPRAISAL_ADOPTED_AGE_YEARS_OLD = 'SET_APPRAISAL_ADOPTED_AGE_YEARS_OLD'
export const SET_APPRAISAL_RIGHT_OF_USE_BOOLEAN = 'SET_APPRAISAL_RIGHT_OF_USE_BOOLEAN'
export const SET_APPRAISAL_PROTECTION_BOOLEAN = 'SET_APPRAISAL_PROTECTION_BOOLEAN'
export const SET_APPRAISAL_PROTECTION_TYPE = 'SET_APPRAISAL_PROTECTION_TYPE'
export const SET_APPRAISAL_PROTECTION_REGIME = 'SET_APPRAISAL_PROTECTION_REGIME'
export const SET_APPRAISAL_PROTECTION_ZONE = 'SET_APPRAISAL_PROTECTION_ZONE'
export const SET_APPRAISAL_URBAN_PLANNING_TYPE = 'SET_APPRAISAL_URBAN_PLANNING_TYPE'
export const SET_APPRAISAL_URBAN_PLANNING_FILE = 'SET_APPRAISAL_URBAN_PLANNING_FILE'
export const SET_APPRAISAL_URBAN_PLANNING_COUNCIL_QUALIFICATION = 'SET_APPRAISAL_URBAN_PLANNING_COUNCIL_QUALIFICATION'
export const SET_APPRAISAL_URBAN_PLANNING_COUNCIL_QUALIFICATION_DESCRIPTION = 'SET_APPRAISAL_URBAN_PLANNING_COUNCIL_QUALIFICATION_DESCRIPTION'
export const SET_APPRAISAL_URBAN_PLANNING_COUNCIL_CLASSIFICATION = 'SET_APPRAISAL_URBAN_PLANNING_COUNCIL_CLASSIFICATION'
export const SET_APPRAISAL_URBAN_PLANNING_COUNCIL_CLASSIFICATION_DESCRIPTION = 'SET_APPRAISAL_URBAN_PLANNING_COUNCIL_CLASSIFICATION_DESCRIPTION'
export const SET_APPRAISAL_URBAN_PLANNING_REGIONAL_QUALIFICATION = 'SET_APPRAISAL_URBAN_PLANNING_REGIONAL_QUALIFICATION'
export const SET_APPRAISAL_URBAN_PLANNING_REGIONAL_QUALIFICATION_DESCRIPTION = 'SET_APPRAISAL_URBAN_PLANNING_REGIONAL_QUALIFICATION_DESCRIPTION'
export const SET_APPRAISAL_URBAN_PLANNING_REGIONAL_CLASSIFICATION = 'SET_APPRAISAL_URBAN_PLANNING_REGIONAL_CLASSIFICATION'
export const SET_APPRAISAL_URBAN_PLANNING_REGIONAL_CLASSIFICATION_DESCRIPTION = 'SET_APPRAISAL_URBAN_PLANNING_REGIONAL_CLASSIFICATION_DESCRIPTION'
export const SET_APPRAISAL_MAP_URBAN_MUC_LAND_COLORS = 'SET_APPRAISAL_MAP_URBAN_MUC_LAND_COLORS'
export const SET_APPRAISAL_MAP_URBAN_MUC_COUNCIL_QUAL = 'SET_APPRAISAL_MAP_URBAN_MUC_COUNCIL_QUAL'
export const SET_APPRAISAL_MAP_URBAN_ICC_TOPO = 'SET_APPRAISAL_MAP_URBAN_ICC_TOPO'
export const SET_APPRAISAL_LAND_REGISTRY_AREA = 'SET_APPRAISAL_LAND_REGISTRY_AREA'
export const SET_APPRAISAL_LAND_CADASTRAL_AREA = 'SET_APPRAISAL_LAND_CADASTRAL_AREA'
export const SET_APPRAISAL_LAND_CHECKED_AREA = 'SET_APPRAISAL_LAND_CHECKED_AREA'
export const SET_APPRAISAL_LAND_ADOPTED_AREA = 'SET_APPRAISAL_LAND_ADOPTED_AREA'
export const SET_APPRAISAL_LAND_INFRASTRUCTURE_PAVING_EXECUTION_PCT = 'SET_APPRAISAL_LAND_INFRASTRUCTURE_PAVING_EXECUTION_PCT'
export const SET_APPRAISAL_LAND_INFRASTRUCTURE_SEWAGE_EXECUTION_PCT = 'SET_APPRAISAL_LAND_INFRASTRUCTURE_SEWAGE_EXECUTION_PCT'
export const SET_APPRAISAL_LAND_INFRASTRUCTURE_PUBLIC_LIGHTING_EXECUTION_PCT = 'SET_APPRAISAL_LAND_INFRASTRUCTURE_PUBLIC_LIGHTING_EXECUTION_PCT'
export const SET_APPRAISAL_LAND_INFRASTRUCTURE_ELECTRICITY_SUPPLY_EXECUTION_PCT = 'SET_APPRAISAL_LAND_INFRASTRUCTURE_ELECTRICITY_SUPPLY_EXECUTION_PCT'
export const SET_APPRAISAL_LAND_INFRASTRUCTURE_PIPED_GAS_EXECUTION_PCT = 'SET_APPRAISAL_LAND_INFRASTRUCTURE_PIPED_GAS_EXECUTION_PCT'
export const SET_APPRAISAL_LAND_INFRASTRUCTURE_TELEPHONE_SERVICE_EXECUTION_PCT = 'SET_APPRAISAL_LAND_INFRASTRUCTURE_TELEPHONE_SERVICE_EXECUTION_PCT'
export const SET_APPRAISAL_LAND_INFRASTRUCTURE_GARDENED_AREAS_EXECUTION_PCT = 'SET_APPRAISAL_LAND_INFRASTRUCTURE_GARDENED_AREAS_EXECUTION_PCT'
export const SET_APPRAISAL_LAND_INFRASTRUCTURE_TOTAL_EXECUTION_PCT = 'SET_APPRAISAL_LAND_INFRASTRUCTURE_TOTAL_EXECUTION_PCT'
export const SET_APPRAISAL_LAND_INFRASTRUCTURE_REPERCUSSION_COST = 'SET_APPRAISAL_LAND_INFRASTRUCTURE_REPERCUSSION_COST'
export const SET_APPRAISAL_LAND_INFRASTRUCTURE_PENDING_INVESTMENT = 'SET_APPRAISAL_LAND_INFRASTRUCTURE_PENDING_INVESTMENT'
export const SET_APPRAISAL_LAND_INFRASTRUCTURE_PAVING = 'SET_APPRAISAL_LAND_INFRASTRUCTURE_PAVING'
export const SET_APPRAISAL_LAND_INFRASTRUCTURE_SEWAGE = 'SET_APPRAISAL_LAND_INFRASTRUCTURE_SEWAGE'
export const SET_APPRAISAL_LAND_INFRASTRUCTURE_PUBLIC_LIGHTING = 'SET_APPRAISAL_LAND_INFRASTRUCTURE_PUBLIC_LIGHTING'
export const SET_APPRAISAL_LAND_INFRASTRUCTURE_ELECTRICITY_SUPPLY = 'SET_APPRAISAL_LAND_INFRASTRUCTURE_ELECTRICITY_SUPPLY'
export const SET_APPRAISAL_LAND_INFRASTRUCTURE_PIPED_GAS = 'SET_APPRAISAL_LAND_INFRASTRUCTURE_PIPED_GAS'
export const SET_APPRAISAL_LAND_INFRASTRUCTURE_TELEPHONE_SERVICE = 'SET_APPRAISAL_LAND_INFRASTRUCTURE_TELEPHONE_SERVICE'
export const SET_APPRAISAL_LAND_INFRASTRUCTURE_GARDENED_AREAS = 'SET_APPRAISAL_LAND_INFRASTRUCTURE_GARDENED_AREAS'
export const SET_APPRAISAL_LAND_IS_PLOT_ACCORDING_TO_LAW = 'SET_APPRAISAL_LAND_IS_PLOT_ACCORDING_TO_LAW'
export const SET_APPRAISAL_LAND_AREA_NOTES = 'SET_APPRAISAL_LAND_AREA_NOTES'
export const SET_APPRAISAL_LAND_INFRASTRUCTURE_NOTES = 'SET_APPRAISAL_LAND_INFRASTRUCTURE_NOTES'
export const SET_APPRAISAL_LAND_INFRASTRUCTURE_CONSERVATION_STATUS = 'SET_APPRAISAL_LAND_INFRASTRUCTURE_CONSERVATION_STATUS'
export const SET_APPRAISAL_LAND_INFRASTRUCTURE_WATER_SUPPLY_EXECUTION_PCT = 'SET_APPRAISAL_LAND_INFRASTRUCTURE_WATER_SUPPLY_EXECUTION_PCT'
export const SET_APPRAISAL_LAND_INFRASTRUCTURE_WATER_SUPPLY = 'SET_APPRAISAL_LAND_INFRASTRUCTURE_WATER_SUPPLY'
export const SET_APPRAISAL_PLOT_OCCUPATION = 'SET_APPRAISAL_PLOT_OCCUPATION'
export const SET_APPRAISAL_PLOT_FREE_AREA_USAGE = 'SET_APPRAISAL_PLOT_FREE_AREA_USAGE'
export const SET_APPRAISAL_FLOORS_NUMBER_UNDERGROUND = 'SET_APPRAISAL_FLOORS_NUMBER_UNDERGROUND'
export const SET_APPRAISAL_FLOORS_NUMBER_OVERGROUND = 'SET_APPRAISAL_FLOORS_NUMBER_OVERGROUND'
export const SET_APPRAISAL_PARKING_SLOTS_INCLUDED_IN_APPRAISAL_NUMBER = 'SET_APPRAISAL_PARKING_SLOTS_INCLUDED_IN_APPRAISAL_NUMBER'
export const SET_APPRAISAL_ENTRANCE_HALL = 'SET_APPRAISAL_ENTRANCE_HALL'
export const SET_APPRAISAL_DOORMAN_SPACE = 'SET_APPRAISAL_DOORMAN_SPACE'
export const SET_APPRAISAL_STAIRCASE = 'SET_APPRAISAL_STAIRCASE'
export const SET_APPRAISAL_SWIMMING_POOL = 'SET_APPRAISAL_SWIMMING_POOL'
export const SET_APPRAISAL_GARDENED_AREAS = 'SET_APPRAISAL_GARDENED_AREAS'
export const SET_APPRAISAL_SPORTS_FACILITIES = 'SET_APPRAISAL_SPORTS_FACILITIES'
export const SET_APPRAISAL_COMMUNITY_ROOM = 'SET_APPRAISAL_COMMUNITY_ROOM'
export const SET_APPRAISAL_STORAGE_ROOM = 'SET_APPRAISAL_STORAGE_ROOM'
export const SET_APPRAISAL_COMMUNITY_PARKING = 'SET_APPRAISAL_COMMUNITY_PARKING'
export const SET_APPRAISAL_FACILITIES_OTHERS = 'SET_APPRAISAL_FACILITIES_OTHERS'
export const SET_APPRAISAL_FLOORS_USAGE_UNDERGROUND = 'SET_APPRAISAL_FLOORS_USAGE_UNDERGROUND'
export const SET_APPRAISAL_FLOORS_USAGE_OVERGROUND = 'SET_APPRAISAL_FLOORS_USAGE_OVERGROUND'
export const SET_APPRAISAL_GROUNDFLOOR_USAGE = 'SET_APPRAISAL_GROUNDFLOOR_USAGE'
export const SET_APPRAISAL_COMMUNICATIONS_AIRPORT = 'SET_APPRAISAL_COMMUNICATIONS_AIRPORT'
export const SET_APPRAISAL_COMMUNICATIONS_HARBOUR = 'SET_APPRAISAL_COMMUNICATIONS_HARBOUR'
export const SET_APPRAISAL_COMMUNICATIONS_TRAIN = 'SET_APPRAISAL_COMMUNICATIONS_TRAIN'
export const SET_APPRAISAL_PUBLIC_TRANSPORT_URBAN_UNDERGROUND = 'SET_APPRAISAL_PUBLIC_TRANSPORT_URBAN_UNDERGROUND'
export const SET_APPRAISAL_PUBLIC_TRANSPORT_INTERURBAN = 'SET_APPRAISAL_PUBLIC_TRANSPORT_INTERURBAN'
export const SET_APPRAISAL_SURROUNDING_FACILITIES_NOTES = 'SET_APPRAISAL_SURROUNDING_FACILITIES_NOTES'
export const SET_APPRAISAL_SURROUNDING_TERRITORIAL_FEATURE = 'SET_APPRAISAL_SURROUNDING_TERRITORIAL_FEATURE'
export const SET_APPRAISAL_SURROUNDING_INCOME_LEVEL = 'SET_APPRAISAL_SURROUNDING_INCOME_LEVEL'
export const SET_APPRAISAL_SURROUNDING_HOMOGENEITY_FEATURE = 'SET_APPRAISAL_SURROUNDING_HOMOGENEITY_FEATURE'
export const SET_APPRAISAL_SURROUNDING_MAIN_USES = 'SET_APPRAISAL_SURROUNDING_MAIN_USES'
export const SET_APPRAISAL_SURROUNDING_DENSITY = 'SET_APPRAISAL_SURROUNDING_DENSITY'
export const SET_APPRAISAL_SURROUNDING_ACCESSIBILITY = 'SET_APPRAISAL_SURROUNDING_ACCESSIBILITY'
export const SET_APPRAISAL_SURROUNDING_CONSOLIDATION_DEGREE = 'SET_APPRAISAL_SURROUNDING_CONSOLIDATION_DEGREE'
export const SET_APPRAISAL_SURROUNDING_OCCUPATION_DEGREE = 'SET_APPRAISAL_SURROUNDING_OCCUPATION_DEGREE'
export const SET_APPRAISAL_SURROUNDING_EVOLUTION_SPEED = 'SET_APPRAISAL_SURROUNDING_EVOLUTION_SPEED'
export const SET_APPRAISAL_SURROUNDING_AVERAGE_AGE = 'SET_APPRAISAL_SURROUNDING_AVERAGE_AGE'
export const SET_APPRAISAL_SURROUNDING_CONSERVATION_STATUS = 'SET_APPRAISAL_SURROUNDING_CONSERVATION_STATUS'
export const SET_APPRAISAL_SURROUNDING_COMMERCIAL_FACILITIES = 'SET_APPRAISAL_SURROUNDING_COMMERCIAL_FACILITIES'
export const SET_APPRAISAL_SURROUNDING_EDUCATIONAL_FACILITIES = 'SET_APPRAISAL_SURROUNDING_EDUCATIONAL_FACILITIES'
export const SET_APPRAISAL_SURROUNDING_PUBLIC_PARKING = 'SET_APPRAISAL_SURROUNDING_PUBLIC_PARKING'
export const SET_APPRAISAL_SURROUNDING_MEDICAL_ASSISTANCE = 'SET_APPRAISAL_SURROUNDING_MEDICAL_ASSISTANCE'
export const SET_APPRAISAL_SURROUNDING_LEISURE = 'SET_APPRAISAL_SURROUNDING_LEISURE'
export const SET_APPRAISAL_CADASTRAL_USAGE = 'SET_APPRAISAL_CADASTRAL_USAGE'
export const SET_APPRAISAL_CADASTRAL_FLOOR = 'SET_APPRAISAL_CADASTRAL_FLOOR'
export const SET_APPRAISAL_CADASTRAL_DOOR = 'SET_APPRAISAL_CADASTRAL_DOOR'
export const SET_APPRAISAL_CADASTRAL_BLOCK = 'SET_APPRAISAL_CADASTRAL_BLOCK'
export const SET_APPRAISAL_CADASTRAL_STAIRCASE = 'SET_APPRAISAL_CADASTRAL_STAIRCASE'
export const SET_APPRAISAL_REGISTRY_NAME = 'SET_APPRAISAL_REGISTRY_NAME'
export const SET_APPRAISAL_REGISTRY_SECTION = 'SET_APPRAISAL_REGISTRY_SECTION'
export const SET_APPRAISAL_REGISTRY_VOLUME = 'SET_APPRAISAL_REGISTRY_VOLUME'
export const SET_APPRAISAL_REGISTRY_BOOK = 'SET_APPRAISAL_REGISTRY_BOOK'
export const SET_APPRAISAL_REGISTRY_PAGE = 'SET_APPRAISAL_REGISTRY_PAGE'
export const SET_APPRAISAL_REGISTRY_REAL_ESTATE_NUMBER = 'SET_APPRAISAL_REGISTRY_REAL_ESTATE_NUMBER'
export const SET_APPRAISAL_REGISTRY_IDUFIR = 'SET_APPRAISAL_REGISTRY_IDUFIR'
export const SET_APPRAISAL_REGISTRY_OWNER = 'SET_APPRAISAL_REGISTRY_OWNER'
export const SET_APPRAISAL_REGISTRY_PROPERTY_COEF = 'SET_APPRAISAL_REGISTRY_PROPERTY_COEF'
export const SET_APPRAISAL_NET_CADASTRAL_AREA = 'SET_APPRAISAL_NET_CADASTRAL_AREA'
export const SET_APPRAISAL_NET_REGISTRY_AREA = 'SET_APPRAISAL_NET_REGISTRY_AREA'
export const SET_APPRAISAL_NET_CHECKED_AREA = 'SET_APPRAISAL_NET_CHECKED_AREA'
export const SET_APPRAISAL_NET_ADOPTED_AREA = 'SET_APPRAISAL_NET_ADOPTED_AREA'
export const SET_APPRAISAL_ENCLOSED_CADASTRAL_AREA = 'SET_APPRAISAL_ENCLOSED_CADASTRAL_AREA'
export const SET_APPRAISAL_ENCLOSED_REGISTRY_AREA = 'SET_APPRAISAL_ENCLOSED_REGISTRY_AREA'
export const SET_APPRAISAL_ENCLOSED_CHECKED_AREA = 'SET_APPRAISAL_ENCLOSED_CHECKED_AREA'
export const SET_APPRAISAL_ENCLOSED_ADOPTED_AREA = 'SET_APPRAISAL_ENCLOSED_ADOPTED_AREA'
export const SET_APPRAISAL_COVERED_TERRACES_TOTAL_CADASTRAL_AREA = 'SET_APPRAISAL_COVERED_TERRACES_TOTAL_CADASTRAL_AREA'
export const SET_APPRAISAL_COVERED_TERRACES_TOTAL_REGISTRY_AREA = 'SET_APPRAISAL_COVERED_TERRACES_TOTAL_REGISTRY_AREA'
export const SET_APPRAISAL_COVERED_TERRACES_TOTAL_CHECKED_AREA = 'SET_APPRAISAL_COVERED_TERRACES_TOTAL_CHECKED_AREA'
export const SET_APPRAISAL_COVERED_TERRACES_TOTAL_ADOPTED_AREA = 'SET_APPRAISAL_COVERED_TERRACES_TOTAL_ADOPTED_AREA'
export const SET_APPRAISAL_UNCOVERED_TERRACES_TOTAL_CADASTRAL_AREA = 'SET_APPRAISAL_UNCOVERED_TERRACES_TOTAL_CADASTRAL_AREA'
export const SET_APPRAISAL_UNCOVERED_TERRACES_TOTAL_REGISTRY_AREA = 'SET_APPRAISAL_UNCOVERED_TERRACES_TOTAL_REGISTRY_AREA'
export const SET_APPRAISAL_UNCOVERED_TERRACES_TOTAL_CHECKED_AREA = 'SET_APPRAISAL_UNCOVERED_TERRACES_TOTAL_CHECKED_AREA'
export const SET_APPRAISAL_UNCOVERED_TERRACES_TOTAL_ADOPTED_AREA = 'SET_APPRAISAL_UNCOVERED_TERRACES_TOTAL_ADOPTED_AREA'
export const SET_APPRAISAL_BUILT_CADASTRAL_AREA = 'SET_APPRAISAL_BUILT_CADASTRAL_AREA'
export const SET_APPRAISAL_BUILT_REGISTRY_AREA = 'SET_APPRAISAL_BUILT_REGISTRY_AREA'
export const SET_APPRAISAL_BUILT_CHECKED_AREA = 'SET_APPRAISAL_BUILT_CHECKED_AREA'
export const SET_APPRAISAL_BUILT_ADOPTED_AREA = 'SET_APPRAISAL_BUILT_ADOPTED_AREA'
export const SET_APPRAISAL_COMMON_ELEMENTS_CADASTRAL_AREA = 'SET_APPRAISAL_COMMON_ELEMENTS_CADASTRAL_AREA'
export const SET_APPRAISAL_COMMON_ELEMENTS_REGISTRY_AREA = 'SET_APPRAISAL_COMMON_ELEMENTS_REGISTRY_AREA'
export const SET_APPRAISAL_COMMON_ELEMENTS_CHECKED_AREA = 'SET_APPRAISAL_COMMON_ELEMENTS_CHECKED_AREA'
export const SET_APPRAISAL_COMMON_ELEMENTS_ADOPTED_AREA = 'SET_APPRAISAL_COMMON_ELEMENTS_ADOPTED_AREA'
export const SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_CADASTRAL_AREA = 'SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_CADASTRAL_AREA'
export const SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_REGISTRY_AREA = 'SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_REGISTRY_AREA'
export const SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_CHECKED_AREA = 'SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_CHECKED_AREA'
export const SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_ADOPTED_AREA = 'SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_ADOPTED_AREA'
export const SET_APPRAISAL_BATHROOMS_NUMBER = 'SET_APPRAISAL_BATHROOMS_NUMBER'
export const SET_APPRAISAL_BEDROOMS_NUMBER = 'SET_APPRAISAL_BEDROOMS_NUMBER'
export const SET_APPRAISAL_NET_SELECTED_AREA = 'SET_APPRAISAL_NET_SELECTED_AREA'
export const SET_APPRAISAL_ENCLOSED_SELECTED_AREA = 'SET_APPRAISAL_ENCLOSED_SELECTED_AREA'
export const SET_APPRAISAL_COVERED_OUTDOORS_SELECTED_AREA = 'SET_APPRAISAL_COVERED_OUTDOORS_SELECTED_AREA'
export const SET_APPRAISAL_BUILT_SELECTED_AREA = 'SET_APPRAISAL_BUILT_SELECTED_AREA'
export const SET_APPRAISAL_COMMON_ELEMENTS_SELECTED_AREA = 'SET_APPRAISAL_COMMON_ELEMENTS_SELECTED_AREA'
export const SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_SELECTED_AREA = 'SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_SELECTED_AREA'
export const SET_APPRAISAL_LAND_SELECTED_AREA = 'SET_APPRAISAL_LAND_SELECTED_AREA'
export const SET_APPRAISAL_REALESTATE_ROOMS_TO_EXTERIOR_NUMBER = 'SET_APPRAISAL_REALESTATE_ROOMS_TO_EXTERIOR_NUMBER'
export const SET_APPRAISAL_REALESTATE_DAY_NIGHT_ZONING = 'SET_APPRAISAL_REALESTATE_DAY_NIGHT_ZONING'
export const SET_APPRAISAL_REALESTATE_SYSTEMS_DOOR_OPENER = 'SET_APPRAISAL_REALESTATE_SYSTEMS_DOOR_OPENER'
export const SET_APPRAISAL_REALESTATE_SYSTEMS_FITTED_CUPBOARDS = 'SET_APPRAISAL_REALESTATE_SYSTEMS_FITTED_CUPBOARDS'
export const SET_APPRAISAL_REALESTATE_SYSTEMS_GAS = 'SET_APPRAISAL_REALESTATE_SYSTEMS_GAS'
export const SET_APPRAISAL_REALESTATE_SYSTEMS_SANITARY_FITTINGS = 'SET_APPRAISAL_REALESTATE_SYSTEMS_SANITARY_FITTINGS'
export const SET_APPRAISAL_REALESTATE_SYSTEMS_TAPS = 'SET_APPRAISAL_REALESTATE_SYSTEMS_TAPS'
export const SET_APPRAISAL_REALESTATE_SYSTEMS_HOT_WATER = 'SET_APPRAISAL_REALESTATE_SYSTEMS_HOT_WATER'
export const SET_APPRAISAL_REALESTATE_SYSTEMS_HEATING = 'SET_APPRAISAL_REALESTATE_SYSTEMS_HEATING'
export const SET_APPRAISAL_REALESTATE_SYSTEMS_AIR_CONDITIONING = 'SET_APPRAISAL_REALESTATE_SYSTEMS_AIR_CONDITIONING'
export const SET_APPRAISAL_REALESTATE_SYSTEMS_TV = 'SET_APPRAISAL_REALESTATE_SYSTEMS_TV'
export const SET_APPRAISAL_REALESTATE_SYSTEMS_TELEPHONE = 'SET_APPRAISAL_REALESTATE_SYSTEMS_TELEPHONE'
export const SET_APPRAISAL_REALESTATE_SYSTEMS_FIRE_PREVENTION = 'SET_APPRAISAL_REALESTATE_SYSTEMS_FIRE_PREVENTION'
export const SET_APPRAISAL_REALESTATE_SYSTEMS_INTRUSION_PREVENTION = 'SET_APPRAISAL_REALESTATE_SYSTEMS_INTRUSION_PREVENTION'
export const SET_APPRAISAL_REALESTATE_FOUNDATION = 'SET_APPRAISAL_REALESTATE_FOUNDATION'
export const SET_APPRAISAL_REALESTATE_STRUCTURE = 'SET_APPRAISAL_REALESTATE_STRUCTURE'
export const SET_APPRAISAL_REALESTATE_ROOF = 'SET_APPRAISAL_REALESTATE_ROOF'
export const SET_APPRAISAL_REALESTATE_EXTERNAL_ENCLOSURES = 'SET_APPRAISAL_REALESTATE_EXTERNAL_ENCLOSURES'
export const SET_APPRAISAL_REALESTATE_INSULATION = 'SET_APPRAISAL_REALESTATE_INSULATION'
export const SET_APPRAISAL_REALESTATE_EXTERNAL_CARPENTRY = 'SET_APPRAISAL_REALESTATE_EXTERNAL_CARPENTRY'
export const SET_APPRAISAL_REALESTATE_GLAZING = 'SET_APPRAISAL_REALESTATE_GLAZING'
export const SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_LIVING = 'SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_LIVING'
export const SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_CORRIDOR = 'SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_CORRIDOR'
export const SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_BEDROOM = 'SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_BEDROOM'
export const SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_KITCHEN = 'SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_KITCHEN'
export const SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_BATHROOM = 'SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_BATHROOM'
export const SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_QUALITY = 'SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_QUALITY'
export const SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_LIVING = 'SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_LIVING'
export const SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_CORRIDOR = 'SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_CORRIDOR'
export const SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_BEDROOM = 'SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_BEDROOM'
export const SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_KITCHEN = 'SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_KITCHEN'
export const SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_BATHROOM = 'SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_BATHROOM'
export const SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_QUALITY = 'SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_QUALITY'
export const SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_LIVING = 'SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_LIVING'
export const SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_CORRIDOR = 'SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_CORRIDOR'
export const SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_BEDROOM = 'SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_BEDROOM'
export const SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_KITCHEN = 'SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_KITCHEN'
export const SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_BATHROOM = 'SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_BATHROOM'
export const SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_QUALITY = 'SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_QUALITY'
export const SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_LIVING = 'SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_LIVING'
export const SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_CORRIDOR = 'SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_CORRIDOR'
export const SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_BEDROOM = 'SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_BEDROOM'
export const SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_KITCHEN = 'SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_KITCHEN'
export const SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_BATHROOM = 'SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_BATHROOM'
export const SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_QUALITY = 'SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_QUALITY'
export const SET_APPRAISAL_REALESTATE_MAIN_ORIENTATION = 'SET_APPRAISAL_REALESTATE_MAIN_ORIENTATION'
export const SET_APPRAISAL_REALESTATE_MAIN_VIEWS = 'SET_APPRAISAL_REALESTATE_MAIN_VIEWS'
export const SET_APPRAISAL_REALESTATE_WINDOWS_SIZE_AND_QUANTITY = 'SET_APPRAISAL_REALESTATE_WINDOWS_SIZE_AND_QUANTITY'
export const SET_APPRAISAL_REALESTATE_NOISE_FACADE = 'SET_APPRAISAL_REALESTATE_NOISE_FACADE'
export const SET_APPRAISAL_REALESTATE_SYSTEMS_SANITARY_FITTINGS_QUALITY = 'SET_APPRAISAL_REALESTATE_SYSTEMS_SANITARY_FITTINGS_QUALITY'
export const SET_APPRAISAL_REALESTATE_SYSTEMS_TAPS_QUALITY = 'SET_APPRAISAL_REALESTATE_SYSTEMS_TAPS_QUALITY'
export const SET_APPRAISAL_BEC_ADJUSTMENT_COEF = 'SET_APPRAISAL_BEC_ADJUSTMENT_COEF'
export const SET_APPRAISAL_BEC_PROPERTY_TYPE = 'SET_APPRAISAL_BEC_PROPERTY_TYPE'
export const SET_APPRAISAL_BEC_NUMBER = 'SET_APPRAISAL_BEC_NUMBER'
export const SET_APPRAISAL_CONSTRUCTION_STATUS = 'SET_APPRAISAL_CONSTRUCTION_STATUS'
export const SET_APPRAISAL_EXPENSES_AND_INDUSTRIAL_BENEFIT_BEC_PCT = 'SET_APPRAISAL_EXPENSES_AND_INDUSTRIAL_BENEFIT_BEC_PCT'
export const SET_APPRAISAL_CONSTRUCTION_COST_NOTES = 'SET_APPRAISAL_CONSTRUCTION_COST_NOTES'
export const SET_APPRAISAL_CADASTRAL_CONSTRUCTION_YEAR = 'SET_APPRAISAL_CADASTRAL_CONSTRUCTION_YEAR'
export const SET_APPRAISAL_CONSTRUCTION_YEAR = 'SET_APPRAISAL_CONSTRUCTION_YEAR'
export const SET_APPRAISAL_LAST_RENOVATION_YEAR = 'SET_APPRAISAL_LAST_RENOVATION_YEAR'
export const SET_APPRAISAL_NUCLEUS_POPULATION = 'SET_APPRAISAL_NUCLEUS_POPULATION'
export const SET_APPRAISAL_NUCLEUS_POPULATION_DENSITY = 'SET_APPRAISAL_NUCLEUS_POPULATION_DENSITY'
export const SET_APPRAISAL_NUCLEUS_POPULATION_GROWTH = 'SET_APPRAISAL_NUCLEUS_POPULATION_GROWTH'
export const SET_APPRAISAL_OCCUPATION_AGRICULTURE_PCT = 'SET_APPRAISAL_OCCUPATION_AGRICULTURE_PCT'
export const SET_APPRAISAL_OCCUPATION_INDUSTRY_PCT = 'SET_APPRAISAL_OCCUPATION_INDUSTRY_PCT'
export const SET_APPRAISAL_OCCUPATION_CONSTRUCTION_PCT = 'SET_APPRAISAL_OCCUPATION_CONSTRUCTION_PCT'
export const SET_APPRAISAL_OCCUPATION_SERVICES_PCT = 'SET_APPRAISAL_OCCUPATION_SERVICES_PCT'
export const SET_APPRAISAL_OCCUPATION_TOTAL_PCT = 'SET_APPRAISAL_OCCUPATION_TOTAL_PCT'
export const SET_APPRAISAL_NUCLEUS_TYPE = 'SET_APPRAISAL_NUCLEUS_TYPE'
export const SET_APPRAISAL_OCCUPATION_DESCRIPTION = 'SET_APPRAISAL_OCCUPATION_DESCRIPTION'
export const SET_APPRAISAL_NUCLEUS_AREA = 'SET_APPRAISAL_NUCLEUS_AREA'
export const SET_APPRAISAL_PROPERTY_TITLE = 'SET_APPRAISAL_PROPERTY_TITLE'
export const SET_APPRAISAL_USAGE_ASSIGNED = 'SET_APPRAISAL_USAGE_ASSIGNED'
export const SET_APPRAISAL_INSPECTION_REALIZED = 'SET_APPRAISAL_INSPECTION_REALIZED'
export const SET_APPRAISAL_ECONOMICAL_ACTIVITY = 'SET_APPRAISAL_ECONOMICAL_ACTIVITY'
export const SET_APPRAISAL_OCCUPANCY_STATUS = 'SET_APPRAISAL_OCCUPANCY_STATUS'
export const SET_APPRAISAL_MARKETSTUDY_ID = 'SET_APPRAISAL_MARKETSTUDY_ID'
export const SET_APPRAISAL_MARKETSTUDIES = 'SET_APPRAISAL_MARKETSTUDIES'
export const SET_APPRAISAL_MAP_URBAN_MUC_LAND_COLORS_OFFSET_X = 'SET_APPRAISAL_MAP_URBAN_MUC_LAND_COLORS_OFFSET_X'
export const SET_APPRAISAL_MAP_URBAN_MUC_LAND_COLORS_OFFSET_Y = 'SET_APPRAISAL_MAP_URBAN_MUC_LAND_COLORS_OFFSET_Y'
export const SET_APPRAISAL_MAP_URBAN_MUC_LAND_COLORS_ZOOM = 'SET_APPRAISAL_MAP_URBAN_MUC_LAND_COLORS_ZOOM'
export const SET_APPRAISAL_MAP_URBAN_MUC_COUNCIL_QUAL_OFFSET_X = 'SET_APPRAISAL_MAP_URBAN_MUC_COUNCIL_QUAL_OFFSET_X'
export const SET_APPRAISAL_MAP_URBAN_MUC_COUNCIL_QUAL_OFFSET_Y = 'SET_APPRAISAL_MAP_URBAN_MUC_COUNCIL_QUAL_OFFSET_Y'
export const SET_APPRAISAL_MAP_URBAN_MUC_COUNCIL_QUAL_ZOOM = 'SET_APPRAISAL_MAP_URBAN_MUC_COUNCIL_QUAL_ZOOM'
export const SET_APPRAISAL_MAP_URBAN_ICC_TOPO_OFFSET_X = 'SET_APPRAISAL_MAP_URBAN_ICC_TOPO_OFFSET_X'
export const SET_APPRAISAL_MAP_URBAN_ICC_TOPO_OFFSET_Y = 'SET_APPRAISAL_MAP_URBAN_ICC_TOPO_OFFSET_Y'
export const SET_APPRAISAL_MAP_URBAN_ICC_TOPO_ZOOM = 'SET_APPRAISAL_MAP_URBAN_ICC_TOPO_ZOOM'
export const SET_APPRAISAL_QUOTE_TRAVEL_ONE_WAY_HOURS = 'SET_APPRAISAL_QUOTE_TRAVEL_ONE_WAY_HOURS'
export const SET_APPRAISAL_QUOTE_TRAVEL_BOTH_WAYS_HOURS = 'SET_APPRAISAL_QUOTE_TRAVEL_BOTH_WAYS_HOURS'
export const SET_APPRAISAL_QUOTE_TRAVEL_FEES_PER_HOUR = 'SET_APPRAISAL_QUOTE_TRAVEL_FEES_PER_HOUR'
export const SET_APPRAISAL_QUOTE_CAR_EXPENSES_ONE_WAY = 'SET_APPRAISAL_QUOTE_CAR_EXPENSES_ONE_WAY'
export const SET_APPRAISAL_QUOTE_CAR_EXPENSES_BOTH_WAYS = 'SET_APPRAISAL_QUOTE_CAR_EXPENSES_BOTH_WAYS'
export const SET_APPRAISAL_QUOTE_TOTAL_TRAVEL_FEES = 'SET_APPRAISAL_QUOTE_TOTAL_TRAVEL_FEES'
export const SET_APPRAISAL_QUOTE_AREA_AVERAGE_UNIT_PRICE = 'SET_APPRAISAL_QUOTE_AREA_AVERAGE_UNIT_PRICE'
export const SET_APPRAISAL_QUOTE_BASE_FEES = 'SET_APPRAISAL_QUOTE_BASE_FEES'
export const SET_APPRAISAL_QUOTE_EXCESS_PCT = 'SET_APPRAISAL_QUOTE_EXCESS_PCT'
export const SET_APPRAISAL_QUOTE_BASE_PRICE = 'SET_APPRAISAL_QUOTE_BASE_PRICE'
export const SET_APPRAISAL_QUOTE_BASE_PRICE_COEF = 'SET_APPRAISAL_QUOTE_BASE_PRICE_COEF'
export const SET_APPRAISAL_USAGE_TYPE = 'SET_APPRAISAL_USAGE_TYPE'
export const SET_APPRAISAL_PARKING_SPOTS_INCLUDED_NUMBER = 'SET_APPRAISAL_PARKING_SPOTS_INCLUDED_NUMBER'


// appraisal_bec_properties
export const SET_APPRAISAL_BEC_PROPERTIES = 'SET_APPRAISAL_BEC_PROPERTIES'

// appraisal_bec_prices
export const SET_APPRAISAL_BEC_PRICES = 'SET_APPRAISAL_BEC_PRICES'

// appraisal_rooms
export const SET_APPRAISAL_ROOMS = 'SET_APPRAISAL_ROOMS'

// appraisal_covered_outdoors
export const SET_APPRAISAL_COVERED_OUTDOORS = 'SET_APPRAISAL_COVERED_OUTDOORS'

// appraisal_uncovered_outdoors
export const SET_APPRAISAL_UNCOVERED_OUTDOORS = 'SET_APPRAISAL_UNCOVERED_OUTDOORS'

// appraisal_constraints
export const SET_APPRAISAL_CONSTRAINTS = 'SET_APPRAISAL_CONSTRAINTS'

// appraisal_warnings
export const SET_APPRAISAL_WARNINGS = 'SET_APPRAISAL_WARNINGS'

// appraisal_notes
export const SET_APPRAISAL_NOTES = 'SET_APPRAISAL_NOTES'

// appraisal_photographs
export const SET_APPRAISAL_PHOTOGRAPHS = 'SET_APPRAISAL_PHOTOGRAPHS'

// appraisal_registryannexes
export const SET_APPRAISAL_REGISTRYANNEXES = 'SET_APPRAISAL_REGISTRYANNEXES'

// appraisal_cadasterannexes
export const SET_APPRAISAL_CADASTERANNEXES = 'SET_APPRAISAL_CADASTERANNEXES'

// appraisal_urbanannexes
export const SET_APPRAISAL_URBANANNEXES = 'SET_APPRAISAL_URBANANNEXES'

// appraisal_planannexes
export const SET_APPRAISAL_PLANANNEXES = 'SET_APPRAISAL_PLANANNEXES'

// appraisal_cessionannexes
export const SET_APPRAISAL_CESSIONANNEXES = 'SET_APPRAISAL_CESSIONANNEXES'

// appraisal_otherannexes
export const SET_APPRAISAL_OTHERANNEXES = 'SET_APPRAISAL_OTHERANNEXES'

// appraisalfile
export const CREATE_NEW_APPRAISALFILE = 'CREATE_NEW_APPRAISALFILE'
export const RESET_APPRAISALFILE = 'RESET_APPRAISALFILE'
export const SET_APPRAISALFILE = 'SET_APPRAISALFILE'
export const SET_APPRAISALFILE_DATE_CREATED = 'SET_APPRAISALFILE_DATE_CREATED'
export const SET_APPRAISALFILE_DATE_MODIFIED = 'SET_APPRAISALFILE_DATE_MODIFIED'
export const SET_APPRAISALFILE_DIRTYNESS = 'SET_APPRAISALFILE_DIRTYNESS'
export const SET_APPRAISALFILE_ID = 'SET_APPRAISALFILE_ID'
export const SET_APPRAISALFILE_PATH = 'SET_APPRAISALFILE_PATH'
export const UPDATE_APPRAISALFILE = 'UPDATE_APPRAISALFILE'
export const SET_APPRAISALFILE_DESCRIPTION = 'SET_APPRAISALFILE_DESCRIPTION'
export const SET_APPRAISALFILE_NUMBER = 'SET_APPRAISALFILE_NUMBER'

// appraisalreport
export const CREATE_NEW_APPRAISALREPORT = 'CREATE_NEW_APPRAISALREPORT'
export const DELETE_APPRAISALREPORT = 'DELETE_APPRAISALREPORT'
export const GET_APPRAISALREPORT = 'GET_APPRAISALREPORT'
export const RESET_APPRAISALREPORT = 'RESET_APPRAISALREPORT'
export const SET_APPRAISALREPORT = 'SET_APPRAISALREPORT'
export const SET_APPRAISALREPORT_DATE_CREATED = 'SET_APPRAISALREPORT_DATE_CREATED'
export const SET_APPRAISALREPORT_DATE_MODIFIED = 'SET_APPRAISALREPORT_DATE_MODIFIED'
export const SET_APPRAISALREPORT_DIRTYNESS = 'SET_APPRAISALREPORT_DIRTYNESS'
export const SET_APPRAISALREPORT_FILE_ID = 'SET_APPRAISALREPORT_FILE_ID'
export const SET_APPRAISALREPORT_ID = 'SET_APPRAISALREPORT_ID'
export const SET_APPRAISALREPORT_NUMBER = 'SET_APPRAISALREPORT_NUMBER'
export const SET_APPRAISALREPORT_PARENT_PATH = 'SET_APPRAISALREPORT_PARENT_PATH'
export const SET_APPRAISALREPORT_PATH = 'SET_APPRAISALREPORT_PATH'
export const SET_APPRAISALREPORT_DESCRIPTION = 'SET_APPRAISALREPORT_DESCRIPTION'
export const SET_APPRAISALREPORT_PETITIONER = 'SET_APPRAISALREPORT_PETITIONER'
export const SET_APPRAISALREPORT_PETITIONER_TYPE = 'SET_APPRAISALREPORT_PETITIONER_TYPE'
export const SET_APPRAISALREPORT_ENTITY = 'SET_APPRAISALREPORT_ENTITY'
export const SET_APPRAISALREPORT_SUPERVISOR = 'SET_APPRAISALREPORT_SUPERVISOR'
export const SET_APPRAISALREPORT_APPRAISER = 'SET_APPRAISALREPORT_APPRAISER'
export const SET_APPRAISALREPORT_REPORTDATE = 'SET_APPRAISALREPORT_REPORTDATE'
export const SET_APPRAISALREPORT_SEND_TO_BDE = 'SET_APPRAISALREPORT_SEND_TO_BDE'
export const SET_APPRAISALREPORT_TITLE = 'SET_APPRAISALREPORT_TITLE'
export const SET_APPRAISALREPORT_VERSION = 'SET_APPRAISALREPORT_VERSION'
export const SET_APPRAISALREPORT_COVER_PHOTO_URL = 'SET_APPRAISALREPORT_COVER_PHOTO_URL'
export const SET_APPRAISALREPORT_STATUS = 'SET_APPRAISALREPORT_STATUS'
export const SET_APPRAISALREPORT_FULL_NUMBER = 'SET_APPRAISALREPORT_FULL_NUMBER'
export const SET_APPRAISALREPORT_SIGNATURE_SV_NAME = 'SET_APPRAISALREPORT_SIGNATURE_SV_NAME'
export const SET_APPRAISALREPORT_SIGNATURE_SV_BASE64 = 'SET_APPRAISALREPORT_SIGNATURE_SV_BASE64'
export const SET_APPRAISALREPORT_SIGNATURE_SV_DATE = 'SET_APPRAISALREPORT_SIGNATURE_SV_DATE'
export const SET_APPRAISALREPORT_SIGNATURE_SV_EMAIL = 'SET_APPRAISALREPORT_SIGNATURE_SV_EMAIL'
export const SET_APPRAISALREPORT_SIGNATURE_SV_UID = 'SET_APPRAISALREPORT_SIGNATURE_SV_UID'
export const SET_APPRAISALREPORT_SIGNATURE_AP_NAME = 'SET_APPRAISALREPORT_SIGNATURE_AP_NAME'
export const SET_APPRAISALREPORT_SIGNATURE_AP_BASE64 = 'SET_APPRAISALREPORT_SIGNATURE_AP_BASE64'
export const SET_APPRAISALREPORT_SIGNATURE_AP_DATE = 'SET_APPRAISALREPORT_SIGNATURE_AP_DATE'
export const SET_APPRAISALREPORT_SIGNATURE_AP_EMAIL = 'SET_APPRAISALREPORT_SIGNATURE_AP_EMAIL'
export const SET_APPRAISALREPORT_SIGNATURE_AP_UID = 'SET_APPRAISALREPORT_SIGNATURE_AP_UID'
export const SET_APPRAISALREPORT_IS_SIGNED = 'SET_APPRAISALREPORT_IS_SIGNED'
export const SET_APPRAISALREPORT_IS_SV_SIGNED = 'SET_APPRAISALREPORT_IS_SV_SIGNED'
export const SET_APPRAISALREPORT_IS_AP_SIGNED = 'SET_APPRAISALREPORT_IS_AP_SIGNED'
export const SET_APPRAISALREPORTS = 'SET_APPRAISALREPORTS'
export const UPDATE_APPRAISALREPORT = 'UPDATE_APPRAISALREPORT'

// appraisalreport_petitioners
export const SET_APPRAISALREPORT_PETITIONERS = 'SET_APPRAISALREPORT_PETITIONERS'

// appraisalreport_realestates
export const SET_APPRAISALREPORT_REALESTATES = 'SET_APPRAISALREPORT_REALESTATES'
export const SET_TEMP_APPRAISALREPORT_REALESTATES = 'SET_TEMP_APPRAISALREPORT_REALESTATES'

//appraisalfile_appraisalreports
export const SET_APPRAISALFILE_APPRAISALREPORTS = 'SET_APPRAISALFILE_APPRAISALREPORTS'
export const SET_TEMP_APPRAISALFILE_APPRAISALREPORTS = 'SET_TEMP_APPRAISALFILE_APPRAISALREPORTS'

// appraisalquote
export const CREATE_NEW_APPRAISALQUOTE = 'CREATE_NEW_APPRAISALQUOTE'
export const DELETE_APPRAISALQUOTE = 'DELETE_APPRAISALQUOTE'
export const GET_APPRAISALQUOTE = 'GET_APPRAISALQUOTE'
export const RESET_APPRAISALQUOTE = 'RESET_APPRAISALQUOTE'
export const SET_APPRAISALQUOTE = 'SET_APPRAISALQUOTE'
export const SET_APPRAISALQUOTE_DATE_CREATED = 'SET_APPRAISALQUOTE_DATE_CREATED'
export const SET_APPRAISALQUOTE_DATE_MODIFIED = 'SET_APPRAISALQUOTE_DATE_MODIFIED'
export const SET_APPRAISALQUOTE_DIRTYNESS = 'SET_APPRAISALQUOTE_DIRTYNESS'
export const SET_APPRAISALQUOTE_FILE_ID = 'SET_APPRAISALQUOTE_FILE_ID'
export const SET_APPRAISALQUOTE_ID = 'SET_APPRAISALQUOTE_ID'
export const SET_APPRAISALQUOTE_NUMBER = 'SET_APPRAISALQUOTE_NUMBER'
export const SET_APPRAISALQUOTE_PARENT_PATH = 'SET_APPRAISALQUOTE_PARENT_PATH'
export const SET_APPRAISALQUOTE_PATH = 'SET_APPRAISALQUOTE_PATH'
export const SET_APPRAISALQUOTE_DESCRIPTION = 'SET_APPRAISALQUOTE_DESCRIPTION'
export const SET_APPRAISALQUOTE_PETITIONER = 'SET_APPRAISALQUOTE_PETITIONER'
export const SET_APPRAISALQUOTE_PETITIONER_TYPE = 'SET_APPRAISALQUOTE_PETITIONER_TYPE'
export const SET_APPRAISALQUOTE_ENTITY = 'SET_APPRAISALQUOTE_ENTITY'
export const SET_APPRAISALQUOTE_SUPERVISOR = 'SET_APPRAISALQUOTE_SUPERVISOR'
export const SET_APPRAISALQUOTE_APPRAISER = 'SET_APPRAISALQUOTE_APPRAISER'
export const SET_APPRAISALQUOTE_REPORTDATE = 'SET_APPRAISALQUOTE_REPORTDATE'
export const SET_APPRAISALQUOTE_SEND_TO_BDE = 'SET_APPRAISALQUOTE_SEND_TO_BDE'
export const SET_APPRAISALQUOTE_TITLE = 'SET_APPRAISALQUOTE_TITLE'
export const SET_APPRAISALQUOTE_VERSION = 'SET_APPRAISALQUOTE_VERSION'
export const SET_APPRAISALQUOTE_COVER_PHOTO_URL = 'SET_APPRAISALQUOTE_COVER_PHOTO_URL'
export const SET_APPRAISALQUOTE_STATUS = 'SET_APPRAISALQUOTE_STATUS'
export const SET_APPRAISALQUOTE_VAT_PCT = 'SET_APPRAISALQUOTE_VAT_PCT'
export const SET_APPRAISALQUOTE_BANK_NAME = 'SET_APPRAISALQUOTE_BANK_NAME'
export const SET_APPRAISALQUOTE_IBAN = 'SET_APPRAISALQUOTE_IBAN'
export const SET_APPRAISALQUOTE_COURT_ASSISTANCE_FEES = 'SET_APPRAISALQUOTE_COURT_ASSISTANCE_FEES'
export const SET_APPRAISALQUOTE_DISCOUNT_PCT = 'SET_APPRAISALQUOTE_DISCOUNT_PCT'
export const SET_APPRAISALQUOTE_DISCOUNT_NOTES = 'SET_APPRAISALQUOTE_DISCOUNT_NOTES'
export const SET_APPRAISALQUOTE_FINAL_PRICE = 'SET_APPRAISALQUOTE_FINAL_PRICE'
export const SET_APPRAISALQUOTE_REQUIREDDOC = 'SET_APPRAISALQUOTE_REQUIREDDOC'
export const SET_APPRAISALQUOTE_FULL_NUMBER = 'SET_APPRAISALQUOTE_FULL_NUMBER'
export const SET_APPRAISALQUOTE_SIGNATURE_NAME = 'SET_APPRAISALQUOTE_SIGNATURE_NAME'
export const SET_APPRAISALQUOTE_SIGNATURE_BASE64 = 'SET_APPRAISALQUOTE_SIGNATURE_BASE64'
export const SET_APPRAISALQUOTE_SIGNATURE_DATE = 'SET_APPRAISALQUOTE_SIGNATURE_DATE'
export const SET_APPRAISALQUOTE_IS_SIGNED = 'SET_APPRAISALQUOTE_IS_SIGNED'
export const SET_APPRAISALQUOTE_SIGNATURE_EMAIL = 'SET_APPRAISALQUOTE_SIGNATURE_EMAIL'
export const SET_APPRAISALQUOTE_SIGNATURE_UID = 'SET_APPRAISALQUOTE_SIGNATURE_UID'
export const SET_APPRAISALQUOTE_PURPOSE = 'SET_APPRAISALQUOTE_PURPOSE'
export const UPDATE_APPRAISALQUOTE = 'UPDATE_APPRAISALQUOTE'

// appraisalquote_petitioners
export const SET_APPRAISALQUOTE_PETITIONERS = 'SET_APPRAISALQUOTE_PETITIONERS'
export const SET_TEMP_APPRAISALQUOTE_PETITIONERS = 'SET_TEMP_APPRAISALQUOTE_PETITIONERS'

// appraisalquote_realestates
export const SET_APPRAISALQUOTE_REALESTATES = 'SET_APPRAISALQUOTE_REALESTATES'
export const SET_TEMP_APPRAISALQUOTE_REALESTATES = 'SET_TEMP_APPRAISALQUOTE_REALESTATES'

// appraisalquote_requireddocs
export const SET_APPRAISALQUOTE_REQUIREDDOCS = 'SET_APPRAISALQUOTE_REQUIREDDOCS'

//appraisalfile_appraisalquotes
export const SET_APPRAISALFILE_APPRAISALQUOTES = 'SET_APPRAISALFILE_APPRAISALQUOTES'
export const SET_TEMP_APPRAISALFILE_APPRAISALQUOTES = 'SET_TEMP_APPRAISALFILE_APPRAISALQUOTES'

// appraisalinvoice
export const CREATE_NEW_APPRAISALINVOICE = 'CREATE_NEW_APPRAISALINVOICE'
export const DELETE_APPRAISALINVOICE = 'DELETE_APPRAISALINVOICE'
export const GET_APPRAISALINVOICE = 'GET_APPRAISALINVOICE'
export const RESET_APPRAISALINVOICE = 'RESET_APPRAISALINVOICE'
export const SET_APPRAISALINVOICE = 'SET_APPRAISALINVOICE'
export const SET_APPRAISALINVOICE_DATE_CREATED = 'SET_APPRAISALINVOICE_DATE_CREATED'
export const SET_APPRAISALINVOICE_DATE_MODIFIED = 'SET_APPRAISALINVOICE_DATE_MODIFIED'
export const SET_APPRAISALINVOICE_DIRTYNESS = 'SET_APPRAISALINVOICE_DIRTYNESS'
export const SET_APPRAISALINVOICE_FILE_ID = 'SET_APPRAISALINVOICE_FILE_ID'
export const SET_APPRAISALINVOICE_ID = 'SET_APPRAISALINVOICE_ID'
export const SET_APPRAISALINVOICE_NUMBER = 'SET_APPRAISALINVOICE_NUMBER'
export const SET_APPRAISALINVOICE_PARENT_PATH = 'SET_APPRAISALINVOICE_PARENT_PATH'
export const SET_APPRAISALINVOICE_PATH = 'SET_APPRAISALINVOICE_PATH'
export const SET_APPRAISALINVOICE_DESCRIPTION = 'SET_APPRAISALINVOICE_DESCRIPTION'
export const SET_APPRAISALINVOICE_PETITIONER = 'SET_APPRAISALINVOICE_PETITIONER'
export const SET_APPRAISALINVOICE_PETITIONER_TYPE = 'SET_APPRAISALINVOICE_PETITIONER_TYPE'
export const SET_APPRAISALINVOICE_ENTITY = 'SET_APPRAISALINVOICE_ENTITY'
export const SET_APPRAISALINVOICE_SUPERVISOR = 'SET_APPRAISALINVOICE_SUPERVISOR'
export const SET_APPRAISALINVOICE_APPRAISER = 'SET_APPRAISALINVOICE_APPRAISER'
export const SET_APPRAISALINVOICE_REPORTDATE = 'SET_APPRAISALINVOICE_REPORTDATE'
export const SET_APPRAISALINVOICE_SEND_TO_BDE = 'SET_APPRAISALINVOICE_SEND_TO_BDE'
export const SET_APPRAISALINVOICE_TITLE = 'SET_APPRAISALINVOICE_TITLE'
export const SET_APPRAISALINVOICE_VERSION = 'SET_APPRAISALINVOICE_VERSION'
export const SET_APPRAISALINVOICE_COVER_PHOTO_URL = 'SET_APPRAISALINVOICE_COVER_PHOTO_URL'
export const SET_APPRAISALINVOICE_STATUS = 'SET_APPRAISALINVOICE_STATUS'
export const SET_APPRAISALINVOICE_VAT_PCT = 'SET_APPRAISALINVOICE_VAT_PCT'
export const SET_APPRAISALINVOICE_QUOTE = 'SET_APPRAISALINVOICE_QUOTE'
export const SET_APPRAISALINVOICE_FULL_NUMBER = 'SET_APPRAISALINVOICE_FULL_NUMBER'
export const UPDATE_APPRAISALINVOICE = 'UPDATE_APPRAISALINVOICE'
export const SET_APPRAISALINVOICE_BASE_PRICE = 'SET_APPRAISALINVOICE_BASE_PRICE'
export const SET_APPRAISALINVOICE_DISCOUNT_PCT = 'SET_APPRAISALINVOICE_DISCOUNT_PCT'
export const SET_APPRAISALINVOICE_FINAL_PRICE = 'SET_APPRAISALINVOICE_FINAL_PRICE'
export const SET_APPRAISALINVOICE_FINAL_PRICE_INCL_VAT = 'SET_APPRAISALINVOICE_FINAL_PRICE_INCL_VAT'
export const SET_APPRAISALINVOICE_DISCOUNT_NOTES = 'SET_APPRAISALINVOICE_DISCOUNT_NOTES'
export const SET_APPRAISALINVOICE_BANK_NAME = 'SET_APPRAISALINVOICE_BANK_NAME'
export const SET_APPRAISALINVOICE_IBAN = 'SET_APPRAISALINVOICE_IBAN'
export const SET_APPRAISALINVOICES = 'SET_APPRAISALINVOICES'
export const SET_APPRAISALQUOTES = 'SET_APPRAISALQUOTES'
export const SET_APPRAISALINVOICE_FISCAL_NUMBER = 'SET_APPRAISALINVOICE_FISCAL_NUMBER'
export const SET_APPRAISALINVOICE_SIGNATURE_NAME = 'SET_APPRAISALINVOICE_SIGNATURE_NAME'
export const SET_APPRAISALINVOICE_SIGNATURE_BASE64 = 'SET_APPRAISALINVOICE_SIGNATURE_BASE64'
export const SET_APPRAISALINVOICE_SIGNATURE_DATE = 'SET_APPRAISALINVOICE_SIGNATURE_DATE'
export const SET_APPRAISALINVOICE_SIGNATURE_EMAIL = 'SET_APPRAISALINVOICE_SIGNATURE_EMAIL'
export const SET_APPRAISALINVOICE_SIGNATURE_UID = 'SET_APPRAISALINVOICE_SIGNATURE_UID'
export const SET_APPRAISALINVOICE_IS_SIGNED = 'SET_APPRAISALINVOICE_IS_SIGNED'


// appraisalinvoice_lines
export const SET_APPRAISALINVOICE_LINES = 'SET_APPRAISALINVOICE_LINES'

// appraisalinvoice_petitioners
export const SET_APPRAISALINVOICE_PETITIONERS = 'SET_APPRAISALINVOICE_PETITIONERS'
export const SET_TEMP_APPRAISALINVOICE_PETITIONERS = 'SET_TEMP_APPRAISALINVOICE_PETITIONERS'

// appraisalinvoice_appraisalquotes
export const SET_APPRAISALINVOICE_APPRAISALQUOTES = 'SET_APPRAISALINVOICE_APPRAISALQUOTES'
export const SET_TEMP_APPRAISALINVOICE_APPRAISALQUOTES = 'SET_TEMP_APPRAISALINVOICE_APPRAISALQUOTES'

//appraisalfile_appraisalinvoices
export const SET_APPRAISALFILE_APPRAISALINVOICES = 'SET_APPRAISALFILE_APPRAISALINVOICES'
export const SET_TEMP_APPRAISALFILE_APPRAISALINVOICES = 'SET_TEMP_APPRAISALFILE_APPRAISALINVOICES'

// becprice
export const CREATE_NEW_BECPRICE = 'CREATE_NEW_BECPRICE'
export const DELETE_BECPRICE = 'DELETE_BECPRICE'
export const GET_BECPRICE = 'GET_BECPRICE'
export const RESET_BECPRICE = 'RESET_BECPRICE'
export const SET_BECPRICE = 'SET_BECPRICE'
export const SET_BECPRICE_DATE_CREATED = 'SET_BECPRICE_DATE_CREATED'
export const SET_BECPRICE_DATE_MODIFIED = 'SET_BECPRICE_DATE_MODIFIED'
export const SET_BECPRICE_DIRTYNESS = 'SET_BECPRICE_DIRTYNESS'
export const SET_BECPRICE_ID = 'SET_BECPRICE_ID'
export const SET_BECPRICE_PARENT_PATH = 'SET_BECPRICE_PARENT_PATH'
export const SET_BECPRICE_PATH = 'SET_BECPRICE_PATH'
export const UPDATE_BECPRICE = 'UPDATE_BECPRICE'
export const SET_BECPRICE_NUMBER = 'SET_BECPRICE_NUMBER'
export const SET_BECPRICE_QUARTER = 'SET_BECPRICE_QUARTER'
export const SET_BECPRICE_YEAR = 'SET_BECPRICE_YEAR'
export const SET_BECPRICE_AIRE_ACONDICIONADO = 'SET_BECPRICE_AIRE_ACONDICIONADO'
export const SET_BECPRICE_ALBANILERIA_ACABADOS_FACHADA = 'SET_BECPRICE_ALBANILERIA_ACABADOS_FACHADA'
export const SET_BECPRICE_ALBANILERIA_ACABADOS_INTERIORES = 'SET_BECPRICE_ALBANILERIA_ACABADOS_INTERIORES'
export const SET_BECPRICE_ALBANILERIA_AYUDAS_INDUSTRIALES = 'SET_BECPRICE_ALBANILERIA_AYUDAS_INDUSTRIALES'
export const SET_BECPRICE_ALBANILERIA_AZOTEAS = 'SET_BECPRICE_ALBANILERIA_AZOTEAS'
export const SET_BECPRICE_ALBANILERIA_GRUESA = 'SET_BECPRICE_ALBANILERIA_GRUESA'
export const SET_BECPRICE_ALBANILERIA_SOLADOS = 'SET_BECPRICE_ALBANILERIA_SOLADOS'
export const SET_BECPRICE_ASCENSORES = 'SET_BECPRICE_ASCENSORES'
export const SET_BECPRICE_CALEFACCION = 'SET_BECPRICE_CALEFACCION'
export const SET_BECPRICE_CARPINTERIA_EXTERIOR = 'SET_BECPRICE_CARPINTERIA_EXTERIOR'
export const SET_BECPRICE_CARPINTERIA_INTERIOR = 'SET_BECPRICE_CARPINTERIA_INTERIOR'
export const SET_BECPRICE_CERRAJERIA = 'SET_BECPRICE_CERRAJERIA'
export const SET_BECPRICE_CIMENTACION_Y_MURO_SOTANO = 'SET_BECPRICE_CIMENTACION_Y_MURO_SOTANO'
export const SET_BECPRICE_ELECTRICIDAD = 'SET_BECPRICE_ELECTRICIDAD'
export const SET_BECPRICE_ENERGIA_SOLAR_ACS = 'SET_BECPRICE_ENERGIA_SOLAR_ACS'
export const SET_BECPRICE_ESTRUCTURA = 'SET_BECPRICE_ESTRUCTURA'
export const SET_BECPRICE_FONTANERIA = 'SET_BECPRICE_FONTANERIA'
export const SET_BECPRICE_FUMISTERIA_Y_MUEBLES_COCINA = 'SET_BECPRICE_FUMISTERIA_Y_MUEBLES_COCINA'
export const SET_BECPRICE_INSTAL_ESPECIALES = 'SET_BECPRICE_INSTAL_ESPECIALES'
export const SET_BECPRICE_JARDINERIA_DECORATIVA = 'SET_BECPRICE_JARDINERIA_DECORATIVA'
export const SET_BECPRICE_MAT_SANITARIO_GRIFERIA = 'SET_BECPRICE_MAT_SANITARIO_GRIFERIA'
export const SET_BECPRICE_MOVIMIENTO_TIERRAS = 'SET_BECPRICE_MOVIMIENTO_TIERRAS'
export const SET_BECPRICE_PERSIANAS = 'SET_BECPRICE_PERSIANAS'
export const SET_BECPRICE_PINTURA_Y_ESTUCOS = 'SET_BECPRICE_PINTURA_Y_ESTUCOS'
export const SET_BECPRICE_RENOVACION_AIRE = 'SET_BECPRICE_RENOVACION_AIRE'
export const SET_BECPRICE_SANEAMIENTO = 'SET_BECPRICE_SANEAMIENTO'
export const SET_BECPRICE_SEGURIDAD_Y_SALUD = 'SET_BECPRICE_SEGURIDAD_Y_SALUD'
export const SET_BECPRICE_SUBTOTAL = 'SET_BECPRICE_SUBTOTAL'
export const SET_BECPRICE_TOTAL = 'SET_BECPRICE_TOTAL'
export const SET_BECPRICE_VIDRIERIA = 'SET_BECPRICE_VIDRIERIA'
export const SET_BECPRICE_YESERIA_CIELOSRASOS = 'SET_BECPRICE_YESERIA_CIELOSRASOS'


// becproperty
export const CREATE_NEW_BECPROPERTY = 'CREATE_NEW_BECPROPERTY'
export const DELETE_BECPROPERTY = 'DELETE_BECPROPERTY'
export const GET_BECPROPERTY = 'GET_BECPROPERTY'
export const RESET_BECPROPERTY = 'RESET_BECPROPERTY'
export const SET_BECPROPERTY = 'SET_BECPROPERTY'
export const SET_BECPROPERTY_DATE_CREATED = 'SET_BECPROPERTY_DATE_CREATED'
export const SET_BECPROPERTY_DATE_MODIFIED = 'SET_BECPROPERTY_DATE_MODIFIED'
export const SET_BECPROPERTY_DIRTYNESS = 'SET_BECPROPERTY_DIRTYNESS'
export const SET_BECPROPERTY_ID = 'SET_BECPROPERTY_ID'
export const SET_BECPROPERTY_PARENT_PATH = 'SET_BECPROPERTY_PARENT_PATH'
export const SET_BECPROPERTY_PATH = 'SET_BECPROPERTY_PATH'
export const UPDATE_BECPROPERTY = 'UPDATE_BECPROPERTY'
export const SET_BECPROPERTY_NAME_CA = 'SET_BECPROPERTY_NAME_CA'
export const SET_BECPROPERTY_NAME_EN = 'SET_BECPROPERTY_NAME_EN'
export const SET_BECPROPERTY_NAME_ES = 'SET_BECPROPERTY_NAME_ES'

// becproperty_becprices
export const SET_BECPROPERTY_BECPRICES = 'SET_BECPROPERTY_BECPRICES'

// constraint
export const CREATE_NEW_CONSTRAINT = 'CREATE_NEW_CONSTRAINT'
export const DELETE_CONSTRAINT = 'DELETE_CONSTRAINT'
export const GET_CONSTRAINT = 'GET_CONSTRAINT'
export const RESET_CONSTRAINT = 'RESET_CONSTRAINT'
export const SET_CONSTRAINT = 'SET_CONSTRAINT'
export const SET_CONSTRAINT_DATE_CREATED = 'SET_CONSTRAINT_DATE_CREATED'
export const SET_CONSTRAINT_DATE_MODIFIED = 'SET_CONSTRAINT_DATE_MODIFIED'
export const SET_CONSTRAINT_DIRTYNESS = 'SET_CONSTRAINT_DIRTYNESS'
export const SET_CONSTRAINT_ID = 'SET_CONSTRAINT_ID'
export const SET_CONSTRAINT_PARENT_PATH = 'SET_CONSTRAINT_PARENT_PATH'
export const SET_CONSTRAINT_PATH = 'SET_CONSTRAINT_PATH'
export const UPDATE_CONSTRAINT = 'UPDATE_CONSTRAINT'

// warning
export const CREATE_NEW_WARNING = 'CREATE_NEW_WARNING'
export const DELETE_WARNING = 'DELETE_WARNING'
export const GET_WARNING = 'GET_WARNING'
export const RESET_WARNING = 'RESET_WARNING'
export const SET_WARNING = 'SET_WARNING'
export const SET_WARNING_DATE_CREATED = 'SET_WARNING_DATE_CREATED'
export const SET_WARNING_DATE_MODIFIED = 'SET_WARNING_DATE_MODIFIED'
export const SET_WARNING_DIRTYNESS = 'SET_WARNING_DIRTYNESS'
export const SET_WARNING_ID = 'SET_WARNING_ID'
export const SET_WARNING_PARENT_PATH = 'SET_WARNING_PARENT_PATH'
export const SET_WARNING_PATH = 'SET_WARNING_PATH'
export const UPDATE_WARNING = 'UPDATE_WARNING'

// note
export const CREATE_NEW_NOTE = 'CREATE_NEW_NOTE'
export const DELETE_NOTE = 'DELETE_NOTE'
export const GET_NOTE = 'GET_NOTE'
export const RESET_NOTE = 'RESET_NOTE'
export const SET_NOTE = 'SET_NOTE'
export const SET_NOTE_DATE_CREATED = 'SET_NOTE_DATE_CREATED'
export const SET_NOTE_DATE_MODIFIED = 'SET_NOTE_DATE_MODIFIED'
export const SET_NOTE_DIRTYNESS = 'SET_NOTE_DIRTYNESS'
export const SET_NOTE_ID = 'SET_NOTE_ID'
export const SET_NOTE_PARENT_PATH = 'SET_NOTE_PARENT_PATH'
export const SET_NOTE_PATH = 'SET_NOTE_PATH'
export const UPDATE_NOTE = 'UPDATE_NOTE'



// contact
export const CREATE_NEW_CONTACT = 'CREATE_NEW_CONTACT'
export const RESET_CONTACT = 'RESET_CONTACT'
export const SET_CONTACT = 'SET_CONTACT'
export const SET_CONTACT_DATE_CREATED = 'SET_CONTACT_DATE_CREATED'
export const SET_CONTACT_DATE_MODIFIED = 'SET_CONTACT_DATE_MODIFIED'
export const SET_CONTACT_DIRTYNESS = 'SET_CONTACT_DIRTYNESS'
export const SET_CONTACT_ID = 'SET_CONTACT_ID'
export const SET_CONTACT_MAIN_EMAIL = 'SET_CONTACT_MAIN_EMAIL'
export const SET_CONTACT_NAME = 'SET_CONTACT_NAME'
export const SET_CONTACT_ORGANIZATION = 'SET_CONTACT_ORGANIZATION'
export const SET_CONTACT_PATH = 'SET_CONTACT_PATH'
export const SET_CONTACT_PERSON_TYPE = 'SET_CONTACT_PERSON_TYPE'
export const SET_CONTACT_REPRESENTATIVE = 'SET_CONTACT_REPRESENTATIVE'
export const SET_CONTACT_REPRESENTATIVE_TIN = 'SET_CONTACT_REPRESENTATIVE_TIN'
export const SET_CONTACT_SURNAMES = 'SET_CONTACT_SURNAMES'
export const SET_CONTACT_TIN = 'SET_CONTACT_TIN'
export const SET_CONTACT_TITLE = 'SET_CONTACT_TITLE'
export const SET_CONTACT_COMPLETE_NAME = 'SET_CONTACT_COMPLETE_NAME'
export const SET_CONTACT_COMPLETE_FISCAL_ADDRESS = 'SET_CONTACT_COMPLETE_FISCAL_ADDRESS'
export const SET_CONTACT_MAIN_TELEPHONENUMBER = 'SET_CONTACT_MAIN_TELEPHONENUMBER'
export const SET_CONTACTS = 'SET_CONTACTS'
export const UPDATE_CONTACT = 'UPDATE_CONTACT'

// appraiser
export const CREATE_NEW_APPRAISER = 'CREATE_NEW_APPRAISER'
export const RESET_APPRAISER = 'RESET_APPRAISER'
export const SET_APPRAISER = 'SET_APPRAISER'
export const SET_APPRAISER_DATE_CREATED = 'SET_APPRAISER_DATE_CREATED'
export const SET_APPRAISER_DATE_MODIFIED = 'SET_APPRAISER_DATE_MODIFIED'
export const SET_APPRAISER_DIRTYNESS = 'SET_APPRAISER_DIRTYNESS'
export const SET_APPRAISER_ID = 'SET_APPRAISER_ID'
export const SET_APPRAISER_NAME = 'SET_APPRAISER_NAME'
export const SET_APPRAISER_ORGANIZATION = 'SET_APPRAISER_ORGANIZATION'
export const SET_APPRAISER_PATH = 'SET_APPRAISER_PATH'
export const SET_APPRAISER_SURNAMES = 'SET_APPRAISER_SURNAMES'
export const SET_APPRAISER_TIN = 'SET_APPRAISER_TIN'
export const SET_APPRAISER_TITLE = 'SET_APPRAISER_TITLE'
export const SET_APPRAISER_COMPLETE_NAME = 'SET_APPRAISER_COMPLETE_NAME'
export const SET_APPRAISER_PROF_ASSOC_REG_NUMBER = 'SET_APPRAISER_PROF_ASSOC_REG_NUMBER'
export const SET_APPRAISERS = 'SET_APPRAISERS'
export const UPDATE_APPRAISER = 'UPDATE_APPRAISER'

// supervisor
export const CREATE_NEW_SUPERVISOR = 'CREATE_NEW_SUPERVISOR'
export const RESET_SUPERVISOR = 'RESET_SUPERVISOR'
export const SET_SUPERVISOR = 'SET_SUPERVISOR'
export const SET_SUPERVISOR_DATE_CREATED = 'SET_SUPERVISOR_DATE_CREATED'
export const SET_SUPERVISOR_DATE_MODIFIED = 'SET_SUPERVISOR_DATE_MODIFIED'
export const SET_SUPERVISOR_DIRTYNESS = 'SET_SUPERVISOR_DIRTYNESS'
export const SET_SUPERVISOR_ID = 'SET_SUPERVISOR_ID'
export const SET_SUPERVISOR_NAME = 'SET_SUPERVISOR_NAME'
export const SET_SUPERVISOR_ORGANIZATION = 'SET_SUPERVISOR_ORGANIZATION'
export const SET_SUPERVISOR_PATH = 'SET_SUPERVISOR_PATH'
export const SET_SUPERVISOR_SURNAMES = 'SET_SUPERVISOR_SURNAMES'
export const SET_SUPERVISOR_TIN = 'SET_SUPERVISOR_TIN'
export const SET_SUPERVISOR_TITLE = 'SET_SUPERVISOR_TITLE'
export const SET_SUPERVISOR_COMPLETE_NAME = 'SET_SUPERVISOR_COMPLETE_NAME'
export const SET_SUPERVISOR_PROF_ASSOC_REG_NUMBER = 'SET_SUPERVISOR_PROF_ASSOC_REG_NUMBER'
export const SET_SUPERVISORS = 'SET_SUPERVISORS'
export const UPDATE_SUPERVISOR = 'UPDATE_SUPERVISOR'

//contact_addresses
export const SET_CONTACT_ADDRESSES = 'SET_CONTACT_ADDRESSES'

//contact_telephonenumbers
export const SET_CONTACT_TELEPHONENUMBERS = 'SET_CONTACT_TELEPHONENUMBERS'

//contact_telephonenumbers
export const SET_CONTACT_EMAILADDRESSES = 'SET_CONTACT_EMAILADDRESSES'

//contact_appraisalinvoices
export const SET_CONTACT_APPRAISALINVOICES = 'SET_CONTACT_APPRAISALINVOICES'

//contact_appraisalquotes
export const SET_CONTACT_APPRAISALQUOTES = 'SET_CONTACT_APPRAISALQUOTES'

//contact_appraisalreports
export const SET_CONTACT_APPRAISALREPORTS = 'SET_CONTACT_APPRAISALREPORTS'

// entity
export const CREATE_NEW_ENTITY = 'CREATE_NEW_ENTITY'
export const RESET_ENTITY = 'RESET_ENTITY'
export const SET_ENTITY = 'SET_ENTITY'
export const SET_ENTITY_DATE_CREATED = 'SET_ENTITY_DATE_CREATED'
export const SET_ENTITY_DATE_MODIFIED = 'SET_ENTITY_DATE_MODIFIED'
export const SET_ENTITY_DIRTYNESS = 'SET_ENTITY_DIRTYNESS'
export const SET_ENTITY_ID = 'SET_ENTITY_ID'
export const SET_ENTITY_PATH = 'SET_ENTITY_PATH'
export const SET_ENTITIES = 'SET_ENTITIES'
export const UPDATE_ENTITY = 'UPDATE_ENTITY'
export const SET_ENTITY_NAME = 'SET_ENTITY_NAME'
export const SET_ENTITY_TIN = 'SET_ENTITY_TIN'
export const SET_ENTITY_BDE_CODE = 'SET_ENTITY_BDE_CODE'

// marketstudy
export const CREATE_NEW_MARKETSTUDY = 'CREATE_NEW_MARKETSTUDY'
export const DELETE_MARKETSTUDY = 'DELETE_MARKETSTUDY'
export const RESET_MARKETSTUDY = 'RESET_MARKETSTUDY'
export const SET_MARKETSTUDY = 'SET_MARKETSTUDY'
export const SET_MARKETSTUDY_DATE_CREATED = 'SET_MARKETSTUDY_DATE_CREATED'
export const SET_MARKETSTUDY_DATE_MODIFIED = 'SET_MARKETSTUDY_DATE_MODIFIED'
export const SET_MARKETSTUDY_DIRTYNESS = 'SET_MARKETSTUDY_DIRTYNESS'
export const SET_MARKETSTUDY_ID = 'SET_MARKETSTUDY_ID'
export const SET_MARKETSTUDY_PARENT_PATH = 'SET_MARKETSTUDY_PARENT_PATH'
export const SET_MARKETSTUDY_PATH = 'SET_MARKETSTUDY_PATH'
export const SET_MARKETSTUDY_PURPOSE = 'SET_MARKETSTUDY_PURPOSE'
export const SET_MARKETSTUDY_PURPOSE_NOTES = 'SET_MARKETSTUDY_PURPOSE_NOTES'
export const SET_MARKETSTUDY_TYPE = 'SET_MARKETSTUDY_TYPE'
export const UPDATE_MARKETSTUDY = 'UPDATE_MARKETSTUDY'
export const SET_MARKETSTUDY_APPRAISAL_ID = 'SET_MARKETSTUDY_APPRAISAL_ID'
export const SET_MARKETSTUDY_DESCRIPTION = 'SET_MARKETSTUDY_DESCRIPTION'
export const SET_MARKETSTUDY_QUERY_AD_TYPE = 'SET_MARKETSTUDY_QUERY_AD_TYPE'
export const SET_MARKETSTUDY_QUERY_DISTANCE_KM = 'SET_MARKETSTUDY_QUERY_DISTANCE_KM'
export const SET_MARKETSTUDY_QUERY_LIMITDATE = 'SET_MARKETSTUDY_QUERY_LIMITDATE'
export const SET_MARKETSTUDY_QUERY_STARTDATE = 'SET_MARKETSTUDY_QUERY_STARTDATE'
export const SET_MARKETSTUDY_REPRESENTATIVE_SAMPLE_TYPICAL_DEVIATION = 'SET_MARKETSTUDY_REPRESENTATIVE_SAMPLE_TYPICAL_DEVIATION'
export const SET_MARKETSTUDY_UNIVERSAL_SAMPLE_TYPICAL_DEVIATION = 'SET_MARKETSTUDY_UNIVERSAL_SAMPLE_TYPICAL_DEVIATION'
export const SET_MARKETSTUDY_WEIGHING = 'SET_MARKETSTUDY_WEIGHING'
export const SET_MARKETSTUDY_WEIGHING_AD_DATE = 'SET_MARKETSTUDY_WEIGHING_AD_DATE'
export const SET_MARKETSTUDY_WEIGHING_PROPERTY_TYPE = 'SET_MARKETSTUDY_WEIGHING_PROPERTY_TYPE'
export const SET_MARKETSTUDY_WEIGHING_QUALITY_OF_NEIGHBOURHOOD = 'SET_MARKETSTUDY_WEIGHING_QUALITY_OF_NEIGHBOURHOOD'
export const SET_MARKETSTUDY_WEIGHING_QUALITY_OF_SITUATION = 'SET_MARKETSTUDY_WEIGHING_QUALITY_OF_SITUATION'
export const SET_MARKETSTUDY_WEIGHING_QUALITY_OF_CONSTRUCTION = 'SET_MARKETSTUDY_WEIGHING_QUALITY_OF_CONSTRUCTION'
export const SET_MARKETSTUDY_WEIGHING_QUALITY_OF_REALESTATE = 'SET_MARKETSTUDY_WEIGHING_QUALITY_OF_REALESTATE'
export const SET_MARKETSTUDY_WEIGHING_ADOPTED_AGE = 'SET_MARKETSTUDY_WEIGHING_ADOPTED_AGE'
export const SET_MARKETSTUDY_WEIGHING_CONSERVATION_STATUS = 'SET_MARKETSTUDY_WEIGHING_CONSERVATION_STATUS'
export const SET_MARKETSTUDY_WEIGHING_FLOOR_NUMBER = 'SET_MARKETSTUDY_WEIGHING_FLOOR_NUMBER'
export const SET_MARKETSTUDY_WEIGHING_ADOPTED_AREA = 'SET_MARKETSTUDY_WEIGHING_ADOPTED_AREA'
export const SET_MARKETSTUDY_WEIGHING_LIFT = 'SET_MARKETSTUDY_WEIGHING_LIFT'
export const SET_MARKETSTUDY_APPRAISED_POINTS = 'SET_MARKETSTUDY_APPRAISED_POINTS'
export const SET_MARKETSTUDY_COMPARABLE_POINTS = 'SET_MARKETSTUDY_COMPARABLE_POINTS'
export const SET_MARKETSTUDY_REGRESSIONLINE_POINTS = 'SET_MARKETSTUDY_REGRESSIONLINE_POINTS'
export const SET_MARKETSTUDY_MARKET_VALUE = 'SET_MARKETSTUDY_MARKET_VALUE'
export const SET_MARKETSTUDY_MARKET_UNIT_VALUE = 'SET_MARKETSTUDY_MARKET_UNIT_VALUE'
export const SET_MARKETSTUDY_REALESTATE_APPRAISALS = 'SET_MARKETSTUDY_REALESTATE_APPRAISALS'
export const SET_MARKETSTUDY_PRICES_ESTIMATED_YEARLY_EVOLUTION_PCT = 'SET_MARKETSTUDY_PRICES_ESTIMATED_YEARLY_EVOLUTION_PCT'
export const SET_MARKETSTUDY_MARKET_VALUE_EVOLUTION_PROBABILITY_PCT = 'SET_MARKETSTUDY_MARKET_VALUE_EVOLUTION_PROBABILITY_PCT'
export const SET_MARKETSTUDY_OFFER_PRODUCTION = 'SET_MARKETSTUDY_OFFER_PRODUCTION'
export const SET_MARKETSTUDY_OFFER_YEARLY_STOCK = 'SET_MARKETSTUDY_OFFER_YEARLY_STOCK'
export const SET_MARKETSTUDY_OFFER_TREND = 'SET_MARKETSTUDY_OFFER_TREND'
export const SET_MARKETSTUDY_DEMAND_LEVEL = 'SET_MARKETSTUDY_DEMAND_LEVEL'
export const SET_MARKETSTUDY_DEMAND_SPEED_OF_SALES = 'SET_MARKETSTUDY_DEMAND_SPEED_OF_SALES'
export const SET_MARKETSTUDY_DEMAND_TREND = 'SET_MARKETSTUDY_DEMAND_TREND'
export const SET_MARKETSTUDY_PRICES_EXPECTANCY = 'SET_MARKETSTUDY_PRICES_EXPECTANCY'
export const SET_MARKETSTUDY_PRICES_PAST_CICLES_VOLATILITY = 'SET_MARKETSTUDY_PRICES_PAST_CICLES_VOLATILITY'
export const SET_MARKETSTUDY_MARKET_CONJUNCTURE = 'SET_MARKETSTUDY_MARKET_CONJUNCTURE'
export const SET_MARKETSTUDY_MARKET_VALUE_REDUCTION_PROBABILITY_EXPECTANCY = 'SET_MARKETSTUDY_MARKET_VALUE_REDUCTION_PROBABILITY_EXPECTANCY'
export const SET_MARKETSTUDY_PRICES_MAX = 'SET_MARKETSTUDY_PRICES_MAX'
export const SET_MARKETSTUDY_PRICES_MIN = 'SET_MARKETSTUDY_PRICES_MIN'
export const SET_MARKETSTUDY_PRICES_MEAN = 'SET_MARKETSTUDY_PRICES_MEAN'
export const SET_MARKETSTUDY_PRICES_MEDIAN = 'SET_MARKETSTUDY_PRICES_MEDIAN'


// marketstudy_ads
export const SET_MARKETSTUDY_MATCHED_ADS = 'SET_MARKETSTUDY_MATCHED_ADS'

// marketstudy_ad_comparables
export const SET_MARKETSTUDY_AD_COMPARABLES = 'SET_MARKETSTUDY_AD_COMPARABLES'

// constraint
export const SET_CONSTRAINT_NAME_CA = 'SET_CONSTRAINT_NAME_CA'
export const SET_CONSTRAINT_NAME_EN = 'SET_CONSTRAINT_NAME_EN'
export const SET_CONSTRAINT_NAME_ES = 'SET_CONSTRAINT_NAME_ES'
export const SET_CONSTRAINT_DEFAULT_CONSTRAINTS = 'SET_CONSTRAINT_DEFAULT_CONSTRAINTS'

// warning
export const SET_WARNING_NAME_CA = 'SET_WARNING_NAME_CA'
export const SET_WARNING_NAME_EN = 'SET_WARNING_NAME_EN'
export const SET_WARNING_NAME_ES = 'SET_WARNING_NAME_ES'
export const SET_CONSTRAINT_DEFAULT_WARNINGS= 'SET_CONSTRAINT_DEFAULT_WARNINGS'

// note
export const SET_NOTE_NAME_CA = 'SET_NOTE_NAME_CA'
export const SET_NOTE_NAME_EN = 'SET_NOTE_NAME_EN'
export const SET_NOTE_NAME_ES = 'SET_NOTE_NAME_ES'
export const SET_CONSTRAINT_DEFAULT_NOTES = 'SET_CONSTRAINT_DEFAULT_NOTES'


// photograph
export const CREATE_NEW_PHOTOGRAPH = 'CREATE_NEW_PHOTOGRAPH'
export const DELETE_PHOTOGRAPH = 'DELETE_PHOTOGRAPH'
export const GET_PHOTOGRAPH = 'GET_PHOTOGRAPH'
export const RESET_PHOTOGRAPH = 'RESET_PHOTOGRAPH'
export const SET_PHOTOGRAPH = 'SET_PHOTOGRAPH'
export const SET_PHOTOGRAPH_DATE_CREATED = 'SET_PHOTOGRAPH_DATE_CREATED'
export const SET_PHOTOGRAPH_DATE_MODIFIED = 'SET_PHOTOGRAPH_DATE_MODIFIED'
export const SET_PHOTOGRAPH_DIRTYNESS = 'SET_PHOTOGRAPH_DIRTYNESS'
export const SET_PHOTOGRAPH_ID = 'SET_PHOTOGRAPH_ID'
export const SET_PHOTOGRAPH_PARENT_PATH = 'SET_PHOTOGRAPH_PARENT_PATH'
export const SET_PHOTOGRAPH_PATH = 'SET_PHOTOGRAPH_PATH'
export const UPDATE_PHOTOGRAPH = 'UPDATE_PHOTOGRAPH'
export const SET_PHOTOGRAPH_NAME_CA = 'SET_PHOTOGRAPH_NAME_CA'
export const SET_PHOTOGRAPH_NAME_EN = 'SET_PHOTOGRAPH_NAME_EN'
export const SET_PHOTOGRAPH_NAME_ES = 'SET_PHOTOGRAPH_NAME_ES'
export const SET_PHOTOGRAPH_URL = 'SET_PHOTOGRAPH_URL'
export const SET_PHOTOGRAPH_FILENAME = 'SET_PHOTOGRAPH_FILENAME'
export const SET_PHOTOGRAPH_IS_COVER_PHOTO = 'SET_PHOTOGRAPH_IS_COVER_PHOTO'

// project
export const CREATE_NEW_PROJECT = 'CREATE_NEW_PROJECT'
export const RESET_PROJECT = 'RESET_PROJECT'
export const SET_PROJECT = 'SET_PROJECT'
export const SET_PROJECT_DATE_CREATED = 'SET_PROJECT_DATE_CREATED'
export const SET_PROJECT_DATE_MODIFIED = 'SET_PROJECT_DATE_MODIFIED'
export const SET_PROJECT_DIRTYNESS = 'SET_PROJECT_DIRTYNESS'
export const SET_PROJECT_ID = 'SET_PROJECT_ID'
export const SET_PROJECT_PATH = 'SET_PROJECT_PATH'
export const SET_PROJECT_PARENT_PATH = 'SET_PROJECT_PARENT_PATH'
export const SET_PROJECT_PROJECTDATE = 'SET_PROJECT_PROJECTDATE'
export const SET_PROJECT_REALESTATE_ID = 'SET_PROJECT_REALESTATE_ID'
export const UPDATE_PROJECT = 'UPDATE_PROJECT'

// registryannex
export const CREATE_NEW_REGISTRYANNEX = 'CREATE_NEW_REGISTRYANNEX'
export const DELETE_REGISTRYANNEX = 'DELETE_REGISTRYANNEX'
export const GET_REGISTRYANNEX = 'GET_REGISTRYANNEX'
export const RESET_REGISTRYANNEX = 'RESET_REGISTRYANNEX'
export const SET_REGISTRYANNEX = 'SET_REGISTRYANNEX'
export const SET_REGISTRYANNEX_DATE_CREATED = 'SET_REGISTRYANNEX_DATE_CREATED'
export const SET_REGISTRYANNEX_DATE_MODIFIED = 'SET_REGISTRYANNEX_DATE_MODIFIED'
export const SET_REGISTRYANNEX_DIRTYNESS = 'SET_REGISTRYANNEX_DIRTYNESS'
export const SET_REGISTRYANNEX_ID = 'SET_REGISTRYANNEX_ID'
export const SET_REGISTRYANNEX_PARENT_PATH = 'SET_REGISTRYANNEX_PARENT_PATH'
export const SET_REGISTRYANNEX_PATH = 'SET_REGISTRYANNEX_PATH'
export const UPDATE_REGISTRYANNEX = 'UPDATE_REGISTRYANNEX'
export const SET_REGISTRYANNEX_NAME_CA = 'SET_REGISTRYANNEX_NAME_CA'
export const SET_REGISTRYANNEX_NAME_EN = 'SET_REGISTRYANNEX_NAME_EN'
export const SET_REGISTRYANNEX_NAME_ES = 'SET_REGISTRYANNEX_NAME_ES'
export const SET_REGISTRYANNEX_URL = 'SET_REGISTRYANNEX_URL'
export const SET_REGISTRYANNEX_FILENAME = 'SET_REGISTRYANNEX_FILENAME'

// cadasterannex
export const CREATE_NEW_CADASTERANNEX = 'CREATE_NEW_CADASTERANNEX'
export const DELETE_CADASTERANNEX = 'DELETE_CADASTERANNEX'
export const GET_CADASTERANNEX = 'GET_CADASTERANNEX'
export const RESET_CADASTERANNEX = 'RESET_CADASTERANNEX'
export const SET_CADASTERANNEX = 'SET_CADASTERANNEX'
export const SET_CADASTERANNEX_DATE_CREATED = 'SET_CADASTERANNEX_DATE_CREATED'
export const SET_CADASTERANNEX_DATE_MODIFIED = 'SET_CADASTERANNEX_DATE_MODIFIED'
export const SET_CADASTERANNEX_DIRTYNESS = 'SET_CADASTERANNEX_DIRTYNESS'
export const SET_CADASTERANNEX_ID = 'SET_CADASTERANNEX_ID'
export const SET_CADASTERANNEX_PARENT_PATH = 'SET_CADASTERANNEX_PARENT_PATH'
export const SET_CADASTERANNEX_PATH = 'SET_CADASTERANNEX_PATH'
export const UPDATE_CADASTERANNEX = 'UPDATE_CADASTERANNEX'
export const SET_CADASTERANNEX_NAME_CA = 'SET_CADASTERANNEX_NAME_CA'
export const SET_CADASTERANNEX_NAME_EN = 'SET_CADASTERANNEX_NAME_EN'
export const SET_CADASTERANNEX_NAME_ES = 'SET_CADASTERANNEX_NAME_ES'
export const SET_CADASTERANNEX_URL = 'SET_CADASTERANNEX_URL'
export const SET_CADASTERANNEX_FILENAME = 'SET_CADASTERANNEX_FILENAME'

// urbanannex
export const CREATE_NEW_URBANANNEX = 'CREATE_NEW_URBANANNEX'
export const DELETE_URBANANNEX = 'DELETE_URBANANNEX'
export const GET_URBANANNEX = 'GET_URBANANNEX'
export const RESET_URBANANNEX = 'RESET_URBANANNEX'
export const SET_URBANANNEX = 'SET_URBANANNEX'
export const SET_URBANANNEX_DATE_CREATED = 'SET_URBANANNEX_DATE_CREATED'
export const SET_URBANANNEX_DATE_MODIFIED = 'SET_URBANANNEX_DATE_MODIFIED'
export const SET_URBANANNEX_DIRTYNESS = 'SET_URBANANNEX_DIRTYNESS'
export const SET_URBANANNEX_ID = 'SET_URBANANNEX_ID'
export const SET_URBANANNEX_PARENT_PATH = 'SET_URBANANNEX_PARENT_PATH'
export const SET_URBANANNEX_PATH = 'SET_URBANANNEX_PATH'
export const UPDATE_URBANANNEX = 'UPDATE_URBANANNEX'
export const SET_URBANANNEX_NAME_CA = 'SET_URBANANNEX_NAME_CA'
export const SET_URBANANNEX_NAME_EN = 'SET_URBANANNEX_NAME_EN'
export const SET_URBANANNEX_NAME_ES = 'SET_URBANANNEX_NAME_ES'
export const SET_URBANANNEX_URL = 'SET_URBANANNEX_URL'
export const SET_URBANANNEX_FILENAME = 'SET_URBANANNEX_FILENAME'

// planannex
export const CREATE_NEW_PLANANNEX = 'CREATE_NEW_PLANANNEX'
export const DELETE_PLANANNEX = 'DELETE_PLANANNEX'
export const GET_PLANANNEX = 'GET_PLANANNEX'
export const RESET_PLANANNEX = 'RESET_PLANANNEX'
export const SET_PLANANNEX = 'SET_PLANANNEX'
export const SET_PLANANNEX_DATE_CREATED = 'SET_PLANANNEX_DATE_CREATED'
export const SET_PLANANNEX_DATE_MODIFIED = 'SET_PLANANNEX_DATE_MODIFIED'
export const SET_PLANANNEX_DIRTYNESS = 'SET_PLANANNEX_DIRTYNESS'
export const SET_PLANANNEX_ID = 'SET_PLANANNEX_ID'
export const SET_PLANANNEX_PARENT_PATH = 'SET_PLANANNEX_PARENT_PATH'
export const SET_PLANANNEX_PATH = 'SET_PLANANNEX_PATH'
export const UPDATE_PLANANNEX = 'UPDATE_PLANANNEX'
export const SET_PLANANNEX_NAME_CA = 'SET_PLANANNEX_NAME_CA'
export const SET_PLANANNEX_NAME_EN = 'SET_PLANANNEX_NAME_EN'
export const SET_PLANANNEX_NAME_ES = 'SET_PLANANNEX_NAME_ES'
export const SET_PLANANNEX_URL = 'SET_PLANANNEX_URL'
export const SET_PLANANNEX_FILENAME = 'SET_PLANANNEX_FILENAME'

// cessionannex
export const CREATE_NEW_CESSIONANNEX = 'CREATE_NEW_CESSIONANNEX'
export const DELETE_CESSIONANNEX = 'DELETE_CESSIONANNEX'
export const GET_CESSIONANNEX = 'GET_CESSIONANNEX'
export const RESET_CESSIONANNEX = 'RESET_CESSIONANNEX'
export const SET_CESSIONANNEX = 'SET_CESSIONANNEX'
export const SET_CESSIONANNEX_DATE_CREATED = 'SET_CESSIONANNEX_DATE_CREATED'
export const SET_CESSIONANNEX_DATE_MODIFIED = 'SET_CESSIONANNEX_DATE_MODIFIED'
export const SET_CESSIONANNEX_DIRTYNESS = 'SET_CESSIONANNEX_DIRTYNESS'
export const SET_CESSIONANNEX_ID = 'SET_CESSIONANNEX_ID'
export const SET_CESSIONANNEX_PARENT_PATH = 'SET_CESSIONANNEX_PARENT_PATH'
export const SET_CESSIONANNEX_PATH = 'SET_CESSIONANNEX_PATH'
export const UPDATE_CESSIONANNEX = 'UPDATE_CESSIONANNEX'
export const SET_CESSIONANNEX_NAME_CA = 'SET_CESSIONANNEX_NAME_CA'
export const SET_CESSIONANNEX_NAME_EN = 'SET_CESSIONANNEX_NAME_EN'
export const SET_CESSIONANNEX_NAME_ES = 'SET_CESSIONANNEX_NAME_ES'
export const SET_CESSIONANNEX_URL = 'SET_CESSIONANNEX_URL'
export const SET_CESSIONANNEX_FILENAME = 'SET_CESSIONANNEX_FILENAME'

// otherannex
export const CREATE_NEW_OTHERANNEX = 'CREATE_NEW_OTHERANNEX'
export const DELETE_OTHERANNEX = 'DELETE_OTHERANNEX'
export const GET_OTHERANNEX = 'GET_OTHERANNEX'
export const RESET_OTHERANNEX = 'RESET_OTHERANNEX'
export const SET_OTHERANNEX = 'SET_OTHERANNEX'
export const SET_OTHERANNEX_DATE_CREATED = 'SET_OTHERANNEX_DATE_CREATED'
export const SET_OTHERANNEX_DATE_MODIFIED = 'SET_OTHERANNEX_DATE_MODIFIED'
export const SET_OTHERANNEX_DIRTYNESS = 'SET_OTHERANNEX_DIRTYNESS'
export const SET_OTHERANNEX_ID = 'SET_OTHERANNEX_ID'
export const SET_OTHERANNEX_PARENT_PATH = 'SET_OTHERANNEX_PARENT_PATH'
export const SET_OTHERANNEX_PATH = 'SET_OTHERANNEX_PATH'
export const UPDATE_OTHERANNEX = 'UPDATE_OTHERANNEX'
export const SET_OTHERANNEX_NAME_CA = 'SET_OTHERANNEX_NAME_CA'
export const SET_OTHERANNEX_NAME_EN = 'SET_OTHERANNEX_NAME_EN'
export const SET_OTHERANNEX_NAME_ES = 'SET_OTHERANNEX_NAME_ES'
export const SET_OTHERANNEX_URL = 'SET_OTHERANNEX_URL'
export const SET_OTHERANNEX_FILENAME = 'SET_OTHERANNEX_FILENAME'


// room
export const CREATE_NEW_ROOM = 'CREATE_NEW_ROOM'
export const DELETE_ROOM = 'DELETE_ROOM'
export const RESET_ROOM = 'RESET_ROOM'
export const SET_ROOM = 'SET_ROOM'
export const SET_ROOM_DATE_CREATED = 'SET_ROOM_DATE_CREATED'
export const SET_ROOM_DATE_MODIFIED = 'SET_ROOM_DATE_MODIFIED'
export const SET_ROOM_DIRTYNESS = 'SET_ROOM_DIRTYNESS'
export const SET_ROOM_ID = 'SET_ROOM_ID'
export const SET_ROOM_PARENT_PATH = 'SET_ROOM_PARENT_PATH'
export const SET_ROOM_PATH = 'SET_ROOM_PATH'
export const UPDATE_ROOM = 'UPDATE_ROOM'
export const SET_ROOM_DESCRIPTION = 'SET_ROOM_DESCRIPTION'
export const SET_ROOM_NETAREA = 'SET_ROOM_NETAREA'
export const SET_ROOM_TYPE = 'SET_ROOM_TYPE'

// line
export const CREATE_NEW_LINE = 'CREATE_NEW_LINE'
export const DELETE_LINE = 'DELETE_LINE'
export const RESET_LINE = 'RESET_LINE'
export const SET_LINE = 'SET_LINE'
export const SET_LINE_DATE_CREATED = 'SET_LINE_DATE_CREATED'
export const SET_LINE_DATE_MODIFIED = 'SET_LINE_DATE_MODIFIED'
export const SET_LINE_DIRTYNESS = 'SET_LINE_DIRTYNESS'
export const SET_LINE_ID = 'SET_LINE_ID'
export const SET_LINE_PARENT_PATH = 'SET_LINE_PARENT_PATH'
export const SET_LINE_PATH = 'SET_LINE_PATH'
export const UPDATE_LINE = 'UPDATE_LINE'
export const SET_LINE_DESCRIPTION = 'SET_LINE_DESCRIPTION'
export const SET_LINE_NETAREA = 'SET_LINE_NETAREA'
export const SET_LINE_TYPE = 'SET_LINE_TYPE'
export const SET_LINE_UNITS = 'SET_LINE_UNITS'
export const SET_LINE_UNIT_PRICE = 'SET_LINE_UNIT_PRICE'
export const SET_LINE_PRICE = 'SET_LINE_PRICE'


// covered_outdoor
export const CREATE_NEW_COVERED_OUTDOOR = 'CREATE_NEW_COVERED_OUTDOOR'
export const DELETE_COVERED_OUTDOOR = 'DELETE_COVERED_OUTDOOR'
export const RESET_COVERED_OUTDOOR = 'RESET_COVERED_OUTDOOR'
export const SET_COVERED_OUTDOOR = 'SET_COVERED_OUTDOOR'
export const SET_COVERED_OUTDOOR_DATE_CREATED = 'SET_COVERED_OUTDOOR_DATE_CREATED'
export const SET_COVERED_OUTDOOR_DATE_MODIFIED = 'SET_COVERED_OUTDOOR_DATE_MODIFIED'
export const SET_COVERED_OUTDOOR_DIRTYNESS = 'SET_COVERED_OUTDOOR_DIRTYNESS'
export const SET_COVERED_OUTDOOR_ID = 'SET_COVERED_OUTDOOR_ID'
export const SET_COVERED_OUTDOOR_PARENT_PATH = 'SET_COVERED_OUTDOOR_PARENT_PATH'
export const SET_COVERED_OUTDOOR_PATH = 'SET_COVERED_OUTDOOR_PATH'
export const UPDATE_COVERED_OUTDOOR = 'UPDATE_COVERED_OUTDOOR'
export const SET_COVERED_OUTDOOR_DESCRIPTION = 'SET_COVERED_OUTDOOR_DESCRIPTION'
export const SET_COVERED_OUTDOOR_NETAREA = 'SET_COVERED_OUTDOOR_NETAREA'
export const SET_COVERED_OUTDOOR_TYPE = 'SET_COVERED_OUTDOOR_TYPE'

// uncovered_outdoor
export const CREATE_NEW_UNCOVERED_OUTDOOR = 'CREATE_NEW_UNCOVERED_OUTDOOR'
export const DELETE_UNCOVERED_OUTDOOR = 'DELETE_UNCOVERED_OUTDOOR'
export const RESET_UNCOVERED_OUTDOOR = 'RESET_UNCOVERED_OUTDOOR'
export const SET_UNCOVERED_OUTDOOR = 'SET_UNCOVERED_OUTDOOR'
export const SET_UNCOVERED_OUTDOOR_DATE_CREATED = 'SET_UNCOVERED_OUTDOOR_DATE_CREATED'
export const SET_UNCOVERED_OUTDOOR_DATE_MODIFIED = 'SET_UNCOVERED_OUTDOOR_DATE_MODIFIED'
export const SET_UNCOVERED_OUTDOOR_DIRTYNESS = 'SET_UNCOVERED_OUTDOOR_DIRTYNESS'
export const SET_UNCOVERED_OUTDOOR_ID = 'SET_UNCOVERED_OUTDOOR_ID'
export const SET_UNCOVERED_OUTDOOR_PARENT_PATH = 'SET_UNCOVERED_OUTDOOR_PARENT_PATH'
export const SET_UNCOVERED_OUTDOOR_PATH = 'SET_UNCOVERED_OUTDOOR_PATH'
export const UPDATE_UNCOVERED_OUTDOOR = 'UPDATE_UNCOVERED_OUTDOOR'
export const SET_UNCOVERED_OUTDOOR_DESCRIPTION = 'SET_UNCOVERED_OUTDOOR_DESCRIPTION'
export const SET_UNCOVERED_OUTDOOR_NETAREA = 'SET_UNCOVERED_OUTDOOR_NETAREA'
export const SET_UNCOVERED_OUTDOOR_TYPE = 'SET_UNCOVERED_OUTDOOR_TYPE'

// telephonenumber
export const CREATE_NEW_TELEPHONENUMBER = 'CREATE_NEW_TELEPHONENUMBER'
export const DELETE_TELEPHONENUMBER = 'DELETE_TELEPHONENUMBER'
export const RESET_TELEPHONENUMBER = 'RESET_TELEPHONENUMBER'
export const SET_TELEPHONENUMBER = 'SET_TELEPHONENUMBER'
export const SET_TELEPHONENUMBER_DATE_CREATED = 'SET_TELEPHONENUMBER_DATE_CREATED'
export const SET_TELEPHONENUMBER_DATE_MODIFIED = 'SET_TELEPHONENUMBER_DATE_MODIFIED'
export const SET_TELEPHONENUMBER_DIRTYNESS = 'SET_TELEPHONENUMBER_DIRTYNESS'
export const SET_TELEPHONENUMBER_ID = 'SET_TELEPHONENUMBER_ID'
export const SET_TELEPHONENUMBER_PATH = 'SET_TELEPHONENUMBER_PATH'
export const UPDATE_TELEPHONENUMBER = 'UPDATE_TELEPHONENUMBER'
export const SET_TELEPHONENUMBER_DESCRIPTION = 'SET_TELEPHONENUMBER_DESCRIPTION'
export const SET_TELEPHONENUMBER_NUMBER = 'SET_TELEPHONENUMBER_NUMBER'
export const SET_TELEPHONENUMBER_PREFIX = 'SET_TELEPHONENUMBER_PREFIX'

// email
export const CREATE_NEW_EMAILADDRESS = 'CREATE_NEW_EMAILADDRESS'
export const DELETE_EMAILADDRESS = 'DELETE_EMAILADDRESS'
export const RESET_EMAILADDRESS = 'RESET_EMAILADDRESS'
export const SET_EMAILADDRESS = 'SET_EMAILADDRESS'
export const SET_EMAILADDRESS_DATE_CREATED = 'SET_EMAILADDRESS_DATE_CREATED'
export const SET_EMAILADDRESS_DATE_MODIFIED = 'SET_EMAILADDRESS_DATE_MODIFIED'
export const SET_EMAILADDRESS_DIRTYNESS = 'SET_EMAILADDRESS_DIRTYNESS'
export const SET_EMAILADDRESS_ID = 'SET_EMAILADDRESS_ID'
export const SET_EMAILADDRESS_PATH = 'SET_EMAILADDRESS_PATH'
export const UPDATE_EMAILADDRESS = 'UPDATE_EMAILADDRESS'
export const SET_EMAILADDRESS_DESCRIPTION = 'SET_EMAILADDRESS_DESCRIPTION'
export const SET_EMAILADDRESS_ADDRESS = 'SET_EMAILADDRESS_ADDRESS'



// WEBPACK FOOTER //
// ./src/store/constants.js